import React from 'react';
import { useHistory } from 'react-router-dom';

const MapBg: React.FC<{ openLiteracyModal: (url: string) => void }> = ({
  openLiteracyModal,
}) => {
  const history = useHistory();
  return (
    <>
      {/* Back arrow */}
      <g className="back-arrow" transform="translate(-20, -11)">
        <image
          width="296"
          height="193"
          opacity="0.61"
          overflow="visible"
          transform="translate(0 -9)"
        />
        <linearGradient
          id="SVGID_50_"
          x1="148.176"
          x2="148.176"
          y1="33.984"
          y2="174.984"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#F64D8B" />
          <stop offset="1" stopColor="#E6275D" />
        </linearGradient>
        <g onClick={() => history.push('/map')} cursor="pointer">
          <path
            fill="url(#SVGID_50_)"
            d="M226.1 55.2h-92.9l.1-11.9c.1-12.4-13.9-19.7-24.1-12.6L42.8 77.5c-8.8 6.2-8.6 19.4.5 25.3l65.9 42.7c10.1 6.6 23.5-.7 23.6-12.7l.1-9.9h93.3c18.7 0 33.9-15.2 33.9-33.9-.1-18.7-15.3-33.8-34-33.8z"
          />
          <g fill="#FFF">
            <path d="M59.9 79c0-.6.2-.9.4-1.1.2-.1.6-.3 1.1-.4 2.3-.5 5.1-.8 8.4-.8 1.1 0 2.1.1 3.1.2s1.9.4 2.7.7 1.5.7 2 1.2.8 1.1.8 1.8c0 .6-.1 1.2-.3 1.7-.2.5-.6 1-1 1.5s-.9.9-1.5 1.3-1.2.8-1.8 1.1c.8.1 1.6.2 2.3.5.7.2 1.3.5 1.9.9.5.4.9.9 1.2 1.5.3.6.4 1.3.4 2 0 1-.3 1.9-.8 2.8-.5.9-1.2 1.6-2.1 2.3s-2 1.2-3.2 1.6-2.6.6-4 .6c-.7 0-1.6 0-2.5-.1s-1.7-.2-2.5-.3c-.6-.1-1-.3-1.3-.7-.3-.3-.5-1-.6-1.9-.1-1-.2-2-.3-2.9-.1-.9-.1-1.8-.2-2.7 0-.9-.1-1.7-.1-2.5v-4.4c-.3.1-.6.1-.9.1-.6 0-.9-.3-1.1-1-.1-.3-.1-.7-.2-1v-1.1-.5c.1-.1.1-.3.1-.4zm7.5 2.8v3.8c1.4-.4 2.6-1 3.5-1.6.9-.6 1.6-1.3 1.9-1.9-.7-.3-1.6-.5-2.9-.5h-1.2c-.4.2-.9.2-1.3.2zm6.4 9.2c0-.3-.1-.5-.3-.7-.2-.2-.5-.3-.8-.5-.3-.1-.7-.2-1.2-.3-.4 0-.9-.1-1.4-.1-.9 0-1.7.1-2.5.2l.2 3.6c.4.1.7.1 1 .1h1c1.2 0 2.2-.2 2.9-.6.7-.3 1.1-.9 1.1-1.7zM93 98.4c-.6-.1-.9-.2-1-.5s-.2-.5-.2-1c-.7.5-1.4.9-2.1 1.2-.8.3-1.6.4-2.4.4-1 0-1.8-.2-2.6-.5s-1.4-.7-2-1.3-1-1.2-1.2-2c-.3-.8-.4-1.6-.4-2.5 0-1.3.2-2.5.7-3.6.5-1.1 1.1-2.1 1.9-2.9.8-.8 1.7-1.5 2.7-1.9 1-.5 2.1-.7 3.1-.7.9 0 1.8.2 2.6.5 0-.4.1-.6.2-.8.1-.1.3-.2.6-.2s.8 0 1.4.1c.6.1 1.1.2 1.6.3.2.1.5.1.6.2.2.1.3.2.5.3.1.1.2.3.3.5 0 .2.1.5.1.9 0 1.8-.1 3.7-.2 5.7s-.3 3.9-.5 5.8c-.1.6-.2 1-.4 1.2-.2.2-.6.4-1.1.5-.2 0-.4.1-.6.1h-1.2c-.1 0-.3.2-.4.2zm-1-5.7c0-.8.1-1.5.1-2.3 0-.8.1-1.6.1-2.4l-.9-.3c-.3-.1-.7-.1-1.1-.1-.6 0-1.1.1-1.6.4-.5.3-.9.6-1.2 1-.3.4-.6.8-.7 1.3-.2.5-.3.9-.3 1.3 0 .8.2 1.4.7 1.8.4.4 1.1.7 1.9.7.5 0 1-.1 1.5-.3.6-.3 1.1-.6 1.5-1.1zM108.5 83.3c.5 0 .9 0 1.4.1.5.1 1 .2 1.5.4s.8.4 1 .6c.2.2.3.6.4 1.2 0 .3.1.6.1.9v.9c0 .7-.1 1.4-.2 2.1-.1.4-.2.7-.3.9-.1.2-.4.2-.9.2-.6 0-1.2 0-1.6-.1-.7-.1-1.2-.6-1.3-1.4 0-.3-.1-.6-.1-.9v-.9c-.5 0-1.1.2-1.5.4-.5.2-.9.5-1.3.8-.4.3-.6.7-.9 1.1-.2.4-.3.9-.3 1.4 0 .5.1.9.2 1.3.2.4.4.8.7 1.1.3.3.7.6 1.1.8.4.2.9.3 1.5.3.3 0 .5 0 .9-.1s.6-.1.9-.2c.3-.1.6-.2.8-.3.3-.1.5-.2.7-.3l.6-.3c.1-.1.3-.1.4-.1.3 0 .5.2.7.6.1.2.2.4.4.7.1.2.2.5.3.8.1.2.1.3.1.5s.1.3.1.4c0 .3-.2.6-.5.9-.3.3-.7.5-1.1.7-.4.2-.9.4-1.4.6-.5.2-1 .3-1.5.4-.5.1-1.1.1-1.6.1-1.3 0-2.3-.1-3.3-.4-.9-.3-1.7-.6-2.3-1s-1.1-.9-1.5-1.5c-.4-.5-.7-1.1-.9-1.6-.2-.5-.4-1.1-.4-1.6-.1-.5-.1-.9-.1-1.3 0-1.1.3-2.2.8-3.1s1.2-1.8 2.1-2.5c.9-.7 1.8-1.2 2.9-1.6 1.1-.8 2.2-1 3.4-1zM116 78.8c0-.6.1-1.1.2-1.3.1-.2.3-.4.7-.5.2-.1.5-.1.8-.2.3 0 .6-.1 1-.1.3 0 .7-.1 1-.1h.9c.3 0 .5.1.6.2.1.1.1.4.1.6 0 .4 0 1.5-.1 3.4s-.1 4.6-.1 8.2c.8-1.1 1.5-2.2 2.3-3.2.8-1 1.6-1.9 2.4-2.8l.5-.5c.2-.1.3-.2.6-.2s.5.1.8.2c.7.4 1.4 1 1.9 1.6.3.3.4.7.4 1 0 .3-.2.7-.5 1.1-.4.5-1 1.1-1.7 1.8s-1.4 1.3-2 1.9c.3 0 .5-.1.8-.1h1.5c.2 0 .4.1.7.1.7.1 1.2.4 1.5.9s.4 1.2.4 2.1c0 .5-.1 1.1-.2 1.9-.1.8-.2 1.4-.4 2-.1.5-.3.8-.4 1.1-.2.2-.4.3-.9.3-.4 0-.9 0-1.4-.1-.5-.1-1-.2-1.5-.4-.2 0-.3-.1-.5-.3-.2-.1-.2-.4-.2-.6v-.2c0-.1 0-.2.1-.4.1-.3.2-.7.2-1.2.1-.5.1-1 .1-1.5-.2 0-.5-.1-.9-.1s-.7-.1-1.2-.1c-.4 0-.8 0-1.2.1-.4 0-.8.1-1.1.3v1.1c0 .4.1.7.1 1.1 0 .3.1.6.1.8v.4c0 .3-.1.6-.3.8-.2.2-.6.3-1.3.3h-2c-.6 0-1-.2-1.2-.4-.2-.2-.3-.6-.4-1.1-.1-.6-.1-1.4-.2-2.2-.1-.9-.1-1.8-.2-2.8-.1-1-.1-2.1-.1-3.2v-3.4-3.3l.3-3zM138.5 86.2c0-.3 0-.6.1-.8 0-.2.1-.4.3-.5.1-.1.3-.2.6-.3.2 0 .6-.1 1-.1v-.8-1.1-1.2c0-.4.1-.7.2-1 .1-.3.3-.5.6-.6.3-.2.7-.3 1.2-.4.5-.1 1.3-.1 2.2-.1.5 0 .8.1 1 .3.2.2.3.6.3 1v.6c0 .3 0 .6-.1 1 0 .4 0 .8-.1 1.2 0 .4 0 .8-.1 1.2.3 0 .7.1 1 .1.3 0 .7.1 1.1.1.4.1.7.2.8.4.2.2.2.5.2.9v.8c0 .3-.1.6-.1.9-.1.4-.2.7-.4.8-.2.2-.5.2-1 .3-.3 0-.6.1-.9.1h-.7c0 .7 0 1.4.1 2.3 0 .9.1 1.7.1 2.5s.1 1.5.1 2.2v1.3c0 .4-.1.6-.2.8s-.4.3-.9.4c-.8.1-1.5.2-2.3.2-.4 0-.7-.1-.9-.3-.2-.2-.3-.5-.4-1-.2-1.4-.4-2.8-.5-4.2-.1-1.4-.2-2.8-.3-4.3l-.8-.1c-.4 0-.7-.1-.9-.3-.2-.1-.3-.5-.3-.9v-.7-.7zM160.3 83.5c.3.1.5.2.6.3s.2.3.2.6v.2c0 .1 0 .2-.1.5 1.6.4 2.8 1.1 3.7 2.3.9 1.1 1.3 2.5 1.3 4.2 0 1.2-.2 2.2-.7 3.1-.5.9-1.1 1.6-1.8 2.2-.8.6-1.6 1.1-2.6 1.4-1 .3-1.9.5-2.9.5-1.3 0-2.5-.2-3.5-.5s-2-.8-2.7-1.4c-.7-.6-1.3-1.4-1.7-2.3-.4-.9-.6-2-.6-3.2 0-1.2.2-2.3.8-3.3.5-1 1.1-1.9 1.9-2.6.8-.7 1.7-1.2 2.7-1.6 1-.4 2-.6 3.1-.6.3 0 .7 0 1.1.1.4-.1.8 0 1.2.1zm-.9 5.7c-.2-.1-.4-.2-.6-.2-.1-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.4 0-.2-.1-.4-.1-.7-1 .1-1.9.5-2.6 1.2-.7.7-1 1.6-1 2.7 0 .4.1.8.3 1.2.2.4.4.6.7.9.3.2.6.4 1 .5s.8.2 1.2.2c.4 0 .8-.1 1.2-.2.4-.1.8-.3 1.1-.5.3-.2.6-.5.8-.9.2-.4.3-.7.3-1.2 0-.6-.2-1.1-.5-1.4-.2-.4-.7-.7-1.2-.9zM196.4 97.4c-.3-2.1-.7-4.1-1.1-6.1-.4-2-.9-4.1-1.4-6.2-.4 1.9-.8 3.8-1.3 5.7s-1.1 3.8-1.7 5.6c-.2.4-.3.8-.6 1-.2.2-.5.4-1 .5-.8.2-1.5.2-2.2.2-.6 0-1.1-.1-1.5-.4-.3-.2-.6-.6-.8-1.1-.7-1.9-1.3-3.8-1.8-5.7-.5-1.9-1-3.9-1.5-5.9-.4 1.8-.8 3.6-1.1 5.6-.3 1.9-.6 4-.9 6.3-.1.5-.2.9-.4 1.2-.2.3-.6.4-1.3.4-.6 0-1.1 0-1.5-.1-.5-.1-.9-.1-1.3-.2-.8-.1-1.2-.6-1.2-1.3v-.3-.3c.5-3 1.1-6 1.8-8.9s1.7-6 2.7-9.1c.2-.5.3-.8.6-1 .2-.2.6-.3 1.1-.4.3 0 .7-.1 1-.1H182.8c.4 0 .8.2 1.1.4.3.2.5.6.8 1.1.7 1.6 1.3 3.2 1.8 4.9.5 1.6 1 3.3 1.5 5.1.4-1.7.8-3.3 1.2-5s1-3.3 1.7-5c.3-.8.9-1.2 1.9-1.4.3 0 .7-.1 1-.1H195.5c.5.1.9.2 1.2.5.3.2.5.6.7 1.2 1.1 2.9 2 5.8 2.8 8.8.8 3 1.4 6.1 1.8 9.2v.5c0 .7-.3 1.1-.8 1.2-.5.1-.9.2-1.4.3-.5.1-1 .1-1.5.1s-.9-.1-1.3-.2-.5-.4-.6-1zM215 98.4c-.6-.1-.9-.2-1-.5s-.2-.5-.2-1c-.7.5-1.4.9-2.1 1.2-.8.3-1.6.4-2.4.4-1 0-1.8-.2-2.6-.5s-1.4-.7-2-1.3-1-1.2-1.2-2c-.3-.8-.4-1.6-.4-2.5 0-1.3.2-2.5.7-3.6.5-1.1 1.1-2.1 1.9-2.9.8-.8 1.7-1.5 2.7-1.9 1-.5 2.1-.7 3.1-.7.9 0 1.8.2 2.6.5 0-.4.1-.6.2-.8.1-.1.3-.2.6-.2s.8 0 1.4.1c.6.1 1.1.2 1.6.3.2.1.5.1.6.2.2.1.3.2.5.3.1.1.2.3.3.5 0 .2.1.5.1.9 0 1.8-.1 3.7-.2 5.7s-.3 3.9-.5 5.8c-.1.6-.2 1-.4 1.2-.2.2-.6.4-1.1.5-.2 0-.4.1-.6.1h-1.2c-.1 0-.3.2-.4.2zm-1-5.7c0-.8.1-1.5.1-2.3 0-.8.1-1.6.1-2.4l-.9-.3c-.3-.1-.7-.1-1.1-.1-.6 0-1.1.1-1.6.4-.5.3-.9.6-1.2 1-.3.4-.6.8-.7 1.3-.2.5-.3.9-.3 1.3 0 .8.2 1.4.7 1.8.4.4 1.1.7 1.9.7.5 0 1-.1 1.5-.3.6-.3 1-.6 1.5-1.1zM222.1 85.7c0-.6.1-1.1.3-1.3.2-.3.5-.5 1.1-.6.4-.1.9-.2 1.5-.2h1.5c.4 0 .7.1.8.3.1.2.2.5.2.9.6-.5 1.3-.9 2.1-1.2.8-.3 1.6-.4 2.4-.4.9 0 1.7.2 2.5.5s1.5.8 2.1 1.4c.6.6 1 1.4 1.4 2.3.3.9.5 2.1.5 3.3 0 1.1-.2 2.2-.6 3.1-.4 1-1 1.8-1.7 2.5s-1.5 1.3-2.4 1.7c-.9.4-1.8.6-2.8.6-1.4 0-2.6-.2-3.6-.6v1.1c0 .4 0 .8.1 1.2v2c0 .5-.1.9-.2 1.1s-.5.5-1 .7c-.2.1-.4.2-.7.3-.3.1-.5.2-.8.3-.3.1-.5.2-.8.2-.2.1-.4.1-.6.1-.6 0-.9-.3-1-1-.2-1.7-.3-3.4-.4-5.1-.1-1.7-.1-3.5-.1-5.4 0-2.5.1-5.1.2-7.8zm5.2 3.5v4.3c.5.3 1.2.5 1.9.5.5 0 1-.1 1.4-.3.5-.2.9-.4 1.2-.7.4-.3.6-.7.9-1.1.2-.4.3-.8.3-1.3 0-1-.3-1.7-.8-2.1-.5-.4-1.1-.6-1.9-.6-.5 0-1.1.1-1.6.3-.5.3-1 .6-1.4 1z" />
          </g>
        </g>
      </g>
      {/* admin island */}
      <g className="admin-island">
        <path
          d="M341.69,707.26a154.1,154.1,0,0,1-18,18.86,1.07,1.07,0,0,1-.16.14c-18.22,16.46-36.47,28-44.81,50.74H0V727.2l23.75-54L34,679l1.23.11,42.61,3.91,25.26,2.31,7,.65,5,.45,13.79,1.27.22,0,1.45.13,5.21.48,9.48.87,16,1.46,6.28.58,14,1.28.28,0,127.21,11.67Z"
          fill="#cd22b1"
        />
        <path
          d="M20,647.19c70.7-22.75,367.57-85.22,546,24.35-27,30.43-118.92,67-200,54.78s-146,54.79-243.24,0S-17.79,659.36,20,647.19Z"
          fill="#b45bc6"
        />
        <path
          d="M565,671.54a88.86,88.86,0,0,1-14.06,13.27,163.1,163.1,0,0,1-16.1,10.85c-5.57,3.32-11.32,6.32-17.15,9.15s-11.8,5.38-17.82,7.79a299.19,299.19,0,0,1-75.49,18.8l-4.87.53-4.88.4c-3.25.3-6.51.41-9.78.59-1.63.11-3.27.09-4.9.13s-3.27.06-4.91,0l-4.91-.08-2.46,0-2.45-.12-4.91-.25-4.91-.41c-3.28-.22-6.53-.68-9.8-1.07-1.67-.21-3.13-.35-4.7-.53s-3.07-.39-4.62-.48c-3.11-.14-6.2-.44-9.31-.37-1.56,0-3.11,0-4.67,0l-4.67.19c-.78,0-1.55.05-2.33.1l-2.34.19-4.67.39-4.67.57-2.33.28-2.33.37-4.66.73-4.66.86c-12.42,2.33-24.78,5.59-37.26,8.72s-25.17,6.13-38.12,8.19c-3.24.5-6.48,1-9.76,1.36-1.63.18-3.26.42-4.9.54l-4.94.4c-1.64.16-3.29.2-4.94.27s-3.3.15-5,.18l-5,0-2.49,0c-.82,0-1.65-.09-2.48-.14a157.8,157.8,0,0,1-39-6.94c-3.13-1.06-6.26-2.13-9.36-3.25s-6.13-2.46-9.14-3.8-5.94-2.84-8.87-4.32l-8.63-4.75c-22.18-12.91-44.6-25.42-67.1-37.92-5.61-3.16-11.22-6.32-16.8-9.56S24.7,675.82,19.3,672.21a97,97,0,0,1-7.88-5.78A34,34,0,0,1,7.8,663,12.89,12.89,0,0,1,5,658.71,5.59,5.59,0,0,1,4.79,656a5.15,5.15,0,0,1,1.14-2.44,12.44,12.44,0,0,1,4-3,46.45,46.45,0,0,1,9.1-3.33,50.61,50.61,0,0,0-8.7,4,11.63,11.63,0,0,0-3.44,3,3.92,3.92,0,0,0-.41,3.94,11.56,11.56,0,0,0,2.68,3.55,33.78,33.78,0,0,0,3.62,3,92.56,92.56,0,0,0,8,5.1c11.1,6.31,22.66,11.94,34.18,17.64s23,11.49,34.5,17.34,22.85,11.92,34.19,18.05l8.42,4.3c2.84,1.33,5.73,2.57,8.59,3.86s5.84,2.28,8.75,3.43,5.94,2,8.91,2.91a149,149,0,0,0,36.84,5.83,186.29,186.29,0,0,0,37.41-2.74c12.44-2,24.8-5.12,37.25-8.24s25-6.28,37.91-8.62l4.83-.86,4.87-.74,2.44-.36,2.45-.29,4.91-.56,4.95-.38,2.47-.19c.82,0,1.65-.06,2.48-.09l5-.14c1.66,0,3.32.06,5,.09,3.32,0,6.64.37,9.95.58,1.66.13,3.31.41,5,.61l4.87.64c3.12.43,6.22.93,9.36,1.21l4.7.48,4.71.32L388,724l2.37.09,4.73.17q4.72.08,9.47.05c3.16-.08,6.33-.09,9.49-.28l4.75-.24,4.73-.37a304.2,304.2,0,0,0,37.68-5.53,312.22,312.22,0,0,0,36.86-10q9.06-3.07,17.93-6.7t17.4-8A164.86,164.86,0,0,0,550,683.56,93.83,93.83,0,0,0,565,671.54Z"
          fill="#e4b9ed"
        />
        <path
          d="M90.51,639.45C139.26,620.51,344,568.51,467,659.72c-18.64,25.33-82,55.73-137.91,45.6s-100.64,45.6-167.73,0S64.42,649.58,90.51,639.45Z"
          fill="#dc9cd0"
        />
        <g>
          <g opacity="0.25">
            <path
              d="M284.29,641.38s9.36-7.44,10.43-10.87,2.55-3.5,1.2-4c-4-1.6-3-6.54,6-3.5,11.29,3.8,10.32,8.43,1.86,7.14-2.07,1.4-2.77,2.35-3.84,3.11-.84.6,1.32,5.28-13.75,10.12Z"
              fill="#531063"
            />
            <ellipse
              cx="302.19"
              cy="626.2"
              rx="1.9"
              ry="6.65"
              transform="translate(-387.56 713.88) rotate(-71.48)"
              fill="#531063"
            />
            <path
              d="M295.68,637c2.81-.36,4.83-1.38,6.73-1.78s4-2.1,6-2.83,8.53-2.44,6.07-7.71c-3-2.34.57-5.11,8.78-2.32s9.67,5.1,7.79,6.31c-1.25.8-1.62,3.88-9.69,4.59s-12.2,2.37-12.74,3-2.29,3.94-8.6,5.13-14.92,2.23-14.92,2.23Z"
              fill="#531063"
            />
            <ellipse
              cx="322.92"
              cy="625.48"
              rx="1.9"
              ry="6.65"
              transform="translate(-372.73 733.04) rotate(-71.48)"
              fill="#531063"
            />
            <path
              d="M304.14,638.6c2.85-.46,7.46.42,10.79.58,1.5.08,3.59.44,5.76.66,3.41.34,6.32-.73,7.08-2.59.88-2.13,5.41-3.45,8.44-.26,2.85,3,4.71,6.67,1.84,8.57-1.52,1-4.19.37-5.92-.68a10.08,10.08,0,0,0-5.39-1.23,27.47,27.47,0,0,1-8.15-.76c-3.14-.7-12.52-1.17-21.31,1.44s-10.63,1.19-10.77.75a12.75,12.75,0,0,1-.28-1.74Z"
              fill="#531063"
            />
            <ellipse
              cx="334.17"
              cy="640.82"
              rx="2.72"
              ry="4.66"
              transform="translate(-325.49 345.58) rotate(-38.35)"
              fill="#531063"
            />
            <path
              d="M303,640.58a11.13,11.13,0,0,0,5.6-4.3c.54-.62,4.66-2.28,12.74-3,6.62-.58,8.12-2.62,8.83-3.92a17.84,17.84,0,0,1-8.05-.68c1.23,1.4,1.79,2.11-.57,2.92s-3.55-.39-10,2.66-5.88,5.27-10.16,5.74c-2.89.31-8.49,2-11.83,3.06,1.51-.21,3.29-.46,5.11-.75Z"
              fill="#531063"
              opacity="0.47"
            />
            <g>
              <path
                d="M314.59,625a4,4,0,0,1-.36,4.21,10.75,10.75,0,0,1,5.42-1.27A18.51,18.51,0,0,1,314.59,625Z"
                fill="#531063"
                opacity="0.47"
              />
              <polygon
                points="313.06 630.31 313.06 630.31 313.06 630.31 313.06 630.31"
                fill="#531063"
              />
            </g>
            <path
              d="M297.28,644.33c8.79-2.61,18.17-2.14,21.31-1.44,4.56,1.27,10.82.41,13.27,1.53,0,0-2.69-2.33-3.05-3.85-.67,1.79-1.31,2.42-5,2.45s-4.85-.8-8.41-1.19a64.77,64.77,0,0,0-11.78.16c-2.58.3-11,3-13,3s-4.13,0-4.13,0l2,.77C290,646,292.71,645.69,297.28,644.33Z"
              fill="#531063"
              opacity="0.47"
            />
            <path
              d="M288,639.44c2.06-.54,1.79-2.85,4.62-4.36s2.35-3,3.63-4.78,1.88-1.45,3.4-1.95a10.36,10.36,0,0,1-3.19-1.35h0a15.84,15.84,0,0,0-1.73,3.51c-1.07,3.43-10.43,10.87-10.43,10.87C285.28,641.21,285.94,640,288,639.44Z"
              fill="#531063"
              opacity="0.47"
            />
            <path
              d="M297.87,637.78a44.8,44.8,0,0,0,7.58-2.67c1.48-.68,8.38-3.46,8-4.12a5,5,0,0,0-.43-.66,13.62,13.62,0,0,1-3.44,1.68h0s-2.94,1.47-5.14,2.44a8.53,8.53,0,0,1-2,.8l-.55.13c-1.75.47-.76.7-3.3,1C297.49,637.07,296,638.09,297.87,637.78Z"
              fill="#531063"
            />
            <path
              d="M337.05,640.3c-1.08-2-3.12-3.58-4.72-3.5a1.73,1.73,0,0,0-1.69,1.55C332.75,637.1,335.64,639.12,337.05,640.3Z"
              fill="#531063"
              opacity="0.47"
            />
            <path
              d="M324.18,623.91c-3.42-1.27-6.77-1.59-7.46-.72-.25.31-.11.73.29,1.19,1-2.12,10.78,1.58,11.46,1.84A14.33,14.33,0,0,0,324.18,623.91Z"
              fill="#531063"
              opacity="0.47"
            />
            <path
              d="M303,624.62l-.61-.37c-3-.94-5.74-1.12-6.36-.34-.29.36-.05.88.56,1.45.18-.05.62.2,1.55,1.1l.18.11C296.18,623,303,624.62,303,624.62Z"
              fill="#531063"
              opacity="0.47"
            />
          </g>
          <g>
            <path
              d="M282.69,644.29s-5.76-12.86-9.42-16.3-3.28-4.63-4.33-4c-3.1,1.88-8.53-2.66-2.21-7.32,7.89-5.81,13-1.55,8.87,4,1,2.66,1.87,3.92,2.43,5.32.45,1.11,6.55,3,7.54,18.3Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="270.55"
              cy="618.95"
              rx="5.49"
              ry="2.61"
              transform="translate(-297.72 253.76) rotate(-33.66)"
              fill="#170"
            />
            <path
              d="M281.14,632.2c.44-2.44-.11-4.77,0-6.54s-1.22-4.66-1.44-6.76-.22-8.43-7.1-10.54c-3.65.56-5.76-4.32,0-8.53s8.9-3.58,9.73-1.2c.55,1.56,4,4.19,2.36,11s-1,11.2-.45,12.09,3.88,4.77,3.33,10.53-2,13.19-2,13.19Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="276.09"
              cy="602.43"
              rx="5.49"
              ry="2.61"
              transform="translate(-287.64 254.06) rotate(-33.66)"
              fill="#170"
            />
            <path
              d="M285.57,626.88c.34-2.55,2.78-5.43,4-7.87.54-1.1,1.6-2.44,2.53-4a6.12,6.12,0,0,0-.83-7.41c-2.21-2.3-2.35-6.8,2.29-6.71,4.35.08,9.2,1.44,10.53,5.1.71,1.94-.86,3.51-2.61,4.05a4.8,4.8,0,0,0-3.09,3.21A13.17,13.17,0,0,1,295,619c-1.78,1.88-5.21,8.76-4.88,17.52s-1.89,9.09-2.44,8.86-2.11-1.1-2.11-1.1Z"
              fill="#64cc2b"
            />
            <ellipse
              cx="297.38"
              cy="605.43"
              rx="2.61"
              ry="5.49"
              transform="translate(-369.18 708.77) rotate(-72.65)"
              fill="#170"
            />
            <path
              d="M287.53,629.26a16.44,16.44,0,0,0-3.29-7.59c-.55-.89-1.22-5.32.45-12.09,1.36-5.54-.55-8.25-1.84-9.78a8.8,8.8,0,0,1-3.26,5.68c2,.11,3,.22,3.21,2.66s-1.55,2.44,0,9.76,4.33,8.54,3.55,12.19c-.52,2.47-.29,8.07-.08,11.45.22-1.33.47-2.89.71-4.51Z"
              fill="#11366d"
              opacity="0.47"
            />
            <g>
              <path
                d="M273,608.48a9.14,9.14,0,0,1,4.78,3.47,7.27,7.27,0,0,1,.19-5.14A12.23,12.23,0,0,1,273,608.48Z"
                fill="#11366d"
                opacity="0.47"
              />
              <polygon
                points="278.68 613.71 278.68 613.71 278.68 613.71 278.68 613.71"
                fill="#170"
              />
            </g>
            <path
              d="M290.12,636.53c-.33-8.76,3.1-15.64,4.88-17.52,2.88-2.55,3.8-8,5.86-9.06,0,0-3.53.3-5.42-.59,1.89,1.89,2.41,2.85,1.31,5.74s-2.42,3.13-4,5.57a34,34,0,0,0-3.44,9.2c-.44,2.22.11,10.76-.44,12.31s-1.22,3.21-1.22,3.21l1.51-.94C289.79,643.35,290.29,641.07,290.12,636.53Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M281.58,640c0-2-2.77-3.55-3.66-6.87s-2.77-4.1-4.43-6.43-1.11-2.55-1.22-4.1a5.92,5.92,0,0,1-2.55,1.43h0a35.21,35.21,0,0,0,3.55,4c3.66,3.44,9.42,16.3,9.42,16.3C282.8,643.4,281.58,642,281.58,640Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M282.69,631.09c.22-1.66-.44-6.21-.77-7.87s-1.45-9.09-2.33-9.31c-.33-.08-.64-.13-.9-.17a14.23,14.23,0,0,1,.9,3.93h0s.8,3.38,1.25,5.81a7.62,7.62,0,0,1,.3,2.18c0,.15,0,.33,0,.53,0,1.7.57,1.12.17,3.32C281.75,630.84,282.47,632.76,282.69,631.09Z"
              fill="#86e04b"
            />
            <path
              d="M297.67,602.81c-2.7-.71-5.12-.31-5.53,1-.24.76.29,1.67,1.29,2.48C292.63,603.7,295.86,603,297.67,602.81Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M274.65,600.26c-2.52,1.68-3.92,4-3.12,5.22a1.8,1.8,0,0,0,1.47.67c-2.16-2.39,5.15-7.1,5.66-7.42A8.81,8.81,0,0,0,274.65,600.26Z"
              fill="#11366d"
              opacity="0.47"
            />
            <path
              d="M269,617.16l-.61.19c-2,1.61-3.07,3.58-2.36,4.64a2,2,0,0,0,1.87.68c0-.18.41-.34,1.75-.36l.18-.06C265,621.15,269,617.16,269,617.16Z"
              fill="#11366d"
              opacity="0.47"
            />
          </g>
          <path
            d="M292.44,609.38a5.72,5.72,0,0,1,.34,4.32,13.72,13.72,0,0,1-1.81,4c-1.52,2.42-3.08,4.8-4.77,7.14a41.07,41.07,0,0,1,3.9-7.68,20,20,0,0,0,1.92-3.7,9.62,9.62,0,0,0,.51-2A4.78,4.78,0,0,0,292.44,609.38Z"
            fill="#86e04b"
          />
          <path
            d="M294.17,601.2c-.58.33-1.14.62-1.64.94a3.34,3.34,0,0,0-1.16,1.1,1.67,1.67,0,0,0,0,1.41c.09.27.23.54.35.83a7.83,7.83,0,0,1,.43.87,7.54,7.54,0,0,1-.83-.56,4.66,4.66,0,0,1-.67-.79,2.2,2.2,0,0,1-.14-2.25,3,3,0,0,1,1.71-1.33A4.36,4.36,0,0,1,294.17,601.2Z"
            fill="#86e04b"
          />
          <path
            d="M272.18,601.72c-.36.56-.72,1.08-1,1.6a3.25,3.25,0,0,0-.52,1.51,1.64,1.64,0,0,0,.63,1.26c.2.2.45.37.69.57s.53.35.79.57a5.77,5.77,0,0,1-1-.11,4.26,4.26,0,0,1-1-.38,2.23,2.23,0,0,1-1.18-1.93,3.13,3.13,0,0,1,.9-2A4.32,4.32,0,0,1,272.18,601.72Z"
            fill="#86e04b"
          />
          <path
            d="M266.38,617.67a19.59,19.59,0,0,0-.8,1.8,3.6,3.6,0,0,0-.26,1.66,2.2,2.2,0,0,0,.75,1.39c.2.22.48.38.72.6a9.69,9.69,0,0,1,.83.58,7.36,7.36,0,0,1-1-.12,4.53,4.53,0,0,1-1-.42,2.59,2.59,0,0,1-1.3-1.89,3.32,3.32,0,0,1,.57-2.17A4.42,4.42,0,0,1,266.38,617.67Z"
            fill="#86e04b"
          />
        </g>
        <g>
          <ellipse
            cx="528.38"
            cy="677.91"
            rx="29.02"
            ry="7.03"
            fill="#8e1442"
            opacity="0.57"
          />
          <g>
            <path
              d="M540.26,627.4c-3.29-.56-11.82-2.79-21.71,0s-3.55,9.68,1.18,10.43,21.93,1.61,24.83-.65S547.9,628.69,540.26,627.4Z"
              fill="#f44e92"
            />
            <path
              d="M546,631.92s9.68,22.14-3.65,38.48H517.9s-13.24-16.8-4.57-38.07C538.18,633.76,546,631.92,546,631.92Z"
              fill="#f44e92"
            />
            <ellipse
              cx="530.1"
              cy="631.89"
              rx="12.2"
              ry="2.49"
              fill="#8e1442"
            />
            <ellipse
              cx="530.1"
              cy="670.38"
              rx="12.2"
              ry="2.49"
              fill="#ff1555"
            />
          </g>
          <path
            d="M510.56,650.74a38.51,38.51,0,0,1,2.75-18.37A31.19,31.19,0,0,0,525,636.86c3.76,5.7,4.62,5.81,4.62,5.81a8.66,8.66,0,0,0,6-5.81,26.43,26.43,0,0,0,10.73-3.92A47.56,47.56,0,0,1,549,654.41l-29.85,4.38Z"
            fill="#8e1442"
            opacity="0.58"
          />
          <g>
            <path
              d="M517.14,636.68c-2.94.23-10.72.14-18.59,4.65s-1,9,3.24,8.68,19.13-3.32,21.13-5.87S524,636.15,517.14,636.68Z"
              fill="#f44e92"
            />
            <path
              d="M523,639.33s13,16.89,5.11,33.73l-20.9,5.23s-14.93-11.55-12.07-31.62C516.72,642.57,523,639.33,523,639.33Z"
              fill="#f44e92"
            />
            <ellipse
              cx="509.41"
              cy="642.71"
              rx="10.77"
              ry="2.2"
              transform="translate(-140.69 142.76) rotate(-14.04)"
              fill="#8e1442"
            />
            <ellipse
              cx="517.64"
              cy="675.66"
              rx="10.77"
              ry="2.2"
              transform="translate(-148.44 145.75) rotate(-14.04)"
              fill="#f44e92"
            />
          </g>
          <path
            d="M524.1,640.94c2.42,3.75,7.83,13.58,6.27,24.53a11.86,11.86,0,0,1-2.68-2.06s-5.42-16.37-14.37-15.55C513.32,647.86,521,645.11,524.1,640.94Z"
            fill="#8e1442"
            opacity="0.45"
          />
          <g>
            <path
              d="M551.26,646.41c-2.49-.87-8.85-3.74-16.93-2.86s-4,7.07-.45,8.28,16.89,4.15,19.45,2.78S557.05,648.42,551.26,646.41Z"
              fill="#f44e92"
            />
            <path
              d="M555.11,650.68s4.63,18.55-7.92,29.53l-19-3.21s-8.11-14.85,1.45-30.3C548.8,651.09,555.11,650.68,555.11,650.68Z"
              fill="#f44e92"
            />
            <ellipse
              cx="542.75"
              cy="648.57"
              rx="1.97"
              ry="9.65"
              transform="translate(-187.24 1075.59) rotate(-80.4)"
              fill="#8e1442"
            />
            <ellipse
              cx="537.67"
              cy="678.59"
              rx="1.97"
              ry="9.65"
              transform="translate(-221.06 1095.6) rotate(-80.4)"
              fill="#f44e92"
            />
          </g>
          <path
            d="M543.77,654.15c11.68,1.17,11.66-1.82,11.66-1.82.79,4.78,2.05,18.87-8.24,27.88l-1.31-.22C553.22,658,543.77,654.15,543.77,654.15Z"
            fill="#8e1442"
            opacity="0.45"
          />
          <path
            d="M523.6,676.1c-10.62,2.65-11.39,3-14.73,2.79-.26-.13-2-.93-2.23-1.07a34.71,34.71,0,0,1-4.32-4.63C509.41,676.2,516.65,676.43,523.6,676.1Z"
            fill="#8e1442"
            opacity="0.45"
          />
        </g>
      </g>
      {/* What's next room */}
      <g
        id="whats_x5F_next_x5F_room"
        onClick={() => openLiteracyModal('/next-room')}
        style={{ cursor: 'pointer' }}
        transform="translate(315, 528)"
      >
        <g>
          <path
            d="M42.69,22.58s2.72,65,0,88.45-.57,55,1.25,58.44,14,1,14,0-3.74-45.87-2.38-54.36-2-92.64-2-92.64Z"
            fill="#c84300"
          />
          <path
            d="M43.94,169.47c1.81,3.4,14,1,14,0,0-.16-.1-1.43-.25-3.48-4.94-1.66-11.86-5.54-12.55-10-.9-5.89.57-37.94.91-44.85s1.24-36.35.9-40c-.28-3-1.36-37.58-1.71-48.62l-2.59,0s2.72,65,0,88.45S42.12,166.07,43.94,169.47Z"
            fill="#a63d00"
          />
          <path
            d="M42.69,31.15a2.94,2.94,0,0,0,3,2.59A65.83,65.83,0,0,0,54,32.45L54,27.34Z"
            fill="#9d3818"
          />
          <path
            d="M82.38,9.74C78.7,14.27,68.65,25.09,54.81,28c-12.63,2.62-24.19,1.77-30.31-1.69C19.8,36,10.17,40.36,8,40.36c-2.49,0-3.62-1.58-1.13-9.06S9.62,20,7.81,18.62-2.61,8.65.79,3C3.67-1.82,19,7.74,24.52,11.71,29.63,7.12,38.57,3,49.17.77,63-2.11,76.53,3.82,81.71,6.51A2.12,2.12,0,0,1,82.38,9.74Z"
            fill="#a63908"
          />
          <path
            d="M82.38,10.76C78.7,15.29,68.65,26.11,54.81,29,42.18,31.6,30.62,30.74,24.5,27.29,19.8,37,10.17,41.38,8,41.38c-2.49,0-3.62-1.59-1.13-9.06S9.62,21,7.81,19.64-2.61,9.67.79,4C3.67-.8,19,8.76,24.52,12.73,29.63,8.14,38.57,4,49.17,1.79,63-1.09,76.53,4.84,81.71,7.53A2.12,2.12,0,0,1,82.38,10.76Z"
            fill="#70220a"
          />
          <path
            d="M82.38,11.44C78.7,16,68.65,26.79,54.81,29.66,42.18,32.28,30.62,31.42,24.5,28,19.8,37.65,10.17,42.06,8,42.06c-2.49,0-3.62-1.59-1.13-9.06s2.72-11.33.91-12.68-10.42-10-7-15.63C3.67-.12,19,9.44,24.52,13.41c5.11-4.6,14.05-8.74,24.65-10.94C63-.41,76.53,5.52,81.71,8.21A2.12,2.12,0,0,1,82.38,11.44Z"
            fill="#f9d91e"
          />
          <path
            d="M68.33,3.16s-6.09,10.91,2.26,19.36"
            fill="none"
            stroke="#ce9e00"
            strokeMiterlimit="10"
            strokeWidth="1.25"
          />
          <ellipse cx="72.31" cy="9.73" rx="1.7" ry="2.72" fill="#ce9e00" />
          <ellipse cx="72.76" cy="9.56" rx="0.51" ry="1.02" fill="#fafee7" />
          <path
            d="M61.14,2.25S55.49,7,56.28,9.9s4.53,4,4.87,5.89-2,3.62-2.49,6.45,2.52,5.14,2.52,5.14"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.91"
          />
          <path
            d="M52.73,2.25s-3.36,4.36-3.47,7.08,4.42,2.6,4.75,5.44-5.54,4.64-4.75,7.13,5.32,3.51,4.75,5.78,0,1.58,0,1.58"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.91"
          />
          <path
            d="M46.13,3.5c-2.53.73-3.1,1.3-2,3.45s1.7,3.74,0,5.89-1.24,4.19,0,5.44,3.74,1.47,1.93,4.19S41.78,26.32,43,27.68a14.69,14.69,0,0,0,3.7,2.53"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.91"
          />
          <path
            d="M39.69,5.43c-2.32.84-3.91,1.41-3.34,3.9s2.49,2.72,1.58,5.44-2.38,2-1.7,5.55,4,2.49,3.4,5.43-3.57,4.8-3.57,4.8"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.91"
          />
          <path
            d="M31.71,8.88c-2.5,1.36-.57,1.92,0,3.51s.57,2.38-.56,4.64-1.93,3.06-.68,4.87S33,23.37,32,25.75a13.43,13.43,0,0,1-2.21,3.85"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.91"
          />
          <path
            d="M25.66,13.12c-.86,3.23,1.29,8.1,0,8.78s-3.91,4.39-2.86,8.31"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.91"
          />
          <path
            d="M17,8.88S15.51,11.71,15.74,17s4,8.16,3.51,10.65-4.58,1.8-3.54,5.82,1.72,3,1.72,3"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.91"
          />
          <path
            d="M8.74,4.85s-3.31,1.2-3.2,3.69,1.81,3.28,3.17,6.23-.18,5.76,0,6.9a31.88,31.88,0,0,0,2.58,6c1.24,2.49-2.83,7.58-3,9.85a16.46,16.46,0,0,0,.23,3.85"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.91"
          />
          <path
            d="M24,24.73C19.13,29.26,12.9,38.32,9.17,37s-1.63-6-1.63-6h0c-.19.63-.41,1.3-.64,2C4.41,40.47,5.54,42.06,8,42.06c2.14,0,11.77-4.41,16.47-14.09,6.12,3.45,17.68,4.31,30.31,1.69C68.65,26.79,78.7,16,82.38,11.44a2.1,2.1,0,0,0,.34-2.1c-4.66,4.17-16.13,13.81-24.51,15.39C47.45,26.77,31.25,28,24,24.73Z"
            fill="#a57e0f"
            opacity="0.46"
          />
          <path
            d="M82.55,9.33A8.35,8.35,0,0,1,76,12.39"
            fill="none"
            stroke="#fafee7"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="0.68"
          />
          <polygon
            points="42.46 107.69 41.67 124.85 55.26 123.04 55.26 105.59 42.46 107.69"
            fill="#9d3818"
            opacity="0.72"
          />
          <polygon
            points="42.69 137.48 41.9 154.63 48.69 152.37 56.96 154.63 55.49 135.38 42.69 137.48"
            fill="#9d3818"
            opacity="0.72"
          />
          <g>
            <path
              d="M30.26,129.26c-.66,3.53-3.92,19.82,0,22.32s16.41-2,20.09-1.7,13.72,3.51,15.43,0,4.65-25.26,0-25.71S30.87,126,30.26,129.26Z"
              fill="#d44000"
            />
            <path
              d="M66.36,148.18c-1.93-1.24-19.14-2.27-24.69-1.47a71.84,71.84,0,0,1-13.22.13c.18,2.27.72,4,1.81,4.74,3.92,2.49,16.41-2,20.09-1.7s13.72,3.51,15.43,0a10.84,10.84,0,0,0,.58-1.7Z"
              fill="#a93b00"
            />
            <path
              d="M30.23,128.25c-.61,3.52-3.62,19.81,0,22.31s15.18-2,18.58-1.7,12.68,3.51,14.27,0,4.3-25.26,0-25.71S30.8,125,30.23,128.25Z"
              fill="#ff41d2"
            />
            <path
              d="M30.91,128.25c1.93-1.36,21.18-6.69,35.45-4.19"
              fill="none"
              stroke="#ff9c4e"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.13"
            />
            <path
              d="M63.08,148.86c.08-.19.36-1.08.45-1.36-3.85-1.27-8.2-2.69-12-4.31-7.47-3.17-10,1.36-14.27,3.4-3.37,1.6-5.76,3.12-8.6.18.23,1.81.72,3.19,1.58,3.79,3.63,2.49,15.18-2,18.58-1.7S61.49,152.37,63.08,148.86Z"
              fill="#c62aa8"
            />
          </g>
          <g>
            <path
              d="M14.05,121.41c-8.72-2.15-2.61-6.91,9.62-24.35,12.92-2.49,77.13-2.15,83.7,1.36-.45,7.13-21.07,11.55-26.73,18.8s-19.48.9-25.82,1.92S14.05,121.41,14.05,121.41Z"
              fill="#ae3a00"
            />
            <path
              d="M14.05,119.26c-2.72-.34-4.53-4.87,7.7-22.31,12.91-2.49,76.79-1.14,83.35,2.37-.45,7.14-18.8,8.5-24.46,15.75S61.16,116,54.82,117,14.05,119.26,14.05,119.26Z"
              fill="#d33c80"
            />
            <path
              d="M22.09,96.72s64.21-2.83,83,2.6"
              fill="none"
              stroke="#ff9c4e"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.13"
            />
            <path
              d="M83.45,114.58a11.12,11.12,0,0,0,.16-1.72c0-.13,0-.32-.09-.36a1.15,1.15,0,0,1-.39.17l-.86.15c-1.14.22-2.23.61-3.35.92a11.22,11.22,0,0,1-3.46.33,23.65,23.65,0,0,1-3.43-.59,28.83,28.83,0,0,0,3.44.51,11,11,0,0,0,3.42-.36c1.12-.3,2.22-.67,3.36-.88l.86-.14a1.55,1.55,0,0,0,.41-.17c.18.09.12.28.15.42A12.45,12.45,0,0,1,83.45,114.58Z"
              fill="#682402"
            />
            <path
              d="M102.37,103.44a4.06,4.06,0,0,0-1.27-.54,3.66,3.66,0,0,0-1.36,0c-.92.14-1.81.4-2.73.53.9-.23,1.79-.46,2.71-.64a3.66,3.66,0,0,1,1.4,0A3.24,3.24,0,0,1,102.37,103.44Z"
              fill="#682402"
            />
            <path
              d="M64.05,115.24a124.27,124.27,0,0,0-24-.68c-6.8.68-10.82-1-14.1,1.19-2.44,1.6-9.8,1.69-13.75-.68-.5,2.93.58,4,1.86,4.19,0,0,34.43-1.25,40.77-2.27s20.16,5.33,25.82-1.92A10.58,10.58,0,0,1,82,113.61C75.74,114.58,67,115.76,64.05,115.24Z"
              fill="#a12880"
            />
            <path
              d="M31.89,115.69a6.82,6.82,0,0,0-2.9-.38c-1,.07-1.95.27-2.93.35s-2,.06-2.95.08a16.86,16.86,0,0,0-2.92.34c-1,.18-1.93.4-2.91.54a14.52,14.52,0,0,1-3,.1,10.51,10.51,0,0,1-1.47-.17,1.66,1.66,0,0,1-.7-.26A.36.36,0,0,1,12,116c0-.13.08-.26-.06-.26a1.85,1.85,0,0,0-1.23.7,3.58,3.58,0,0,0-.73,1.27,3.7,3.7,0,0,1,.71-1.29,1.87,1.87,0,0,1,1.26-.73.13.13,0,0,1,.14.13l0,.19a.32.32,0,0,0,.14.29,1.73,1.73,0,0,0,.68.24,11.85,11.85,0,0,0,1.46.16,15.1,15.1,0,0,0,2.93-.12c1-.15,1.93-.37,2.9-.56a17,17,0,0,1,2.93-.33,29,29,0,0,0,2.95,0c1-.08,1.95-.27,2.93-.34A7,7,0,0,1,31.89,115.69Z"
              fill="#682402"
            />
          </g>
          <polygon
            points="43.66 55.48 43.66 69.98 55.32 65.85 54.67 52.73 43.66 55.48"
            fill="#9d3818"
            opacity="0.72"
          />
          <polygon
            points="43.71 72.47 43.71 86.97 55.37 82.84 54.72 69.72 43.71 72.47"
            fill="#9d3818"
            opacity="0.72"
          />
          <g>
            <path
              d="M9,84.47c-2.27-.11-.23-2,4.53-3.28S41.84,72,47.16,69s40.55-12.46,42-13.48,3.74.79,2.72,5.44-2.38,7.7-2,8.94-7.59.91-12.23,2.72S66.42,77.79,63.7,78.47,54,81.42,52,81.19s-6.57.23-12.23,2-7.93,6.57-11.55,7.93-13.48,7.81-15.74,5-.8-4.76-1.7-5.78S9,84.47,9,84.47Z"
              fill="#00c4b8"
            />
            <path
              d="M7,82.55c-2.27-.12-.23-2,4.53-3.29S39.8,70.09,45.12,67s40.55-12.46,42-13.47,6.06.28,5,4.92-4.7,8.21-4.36,9.46-7.59.9-12.23,2.72c-4.43,1.73-11,5.16-13.93,5.89-2.72.68-9.74,2.94-11.67,2.71s-6.56.23-12.23,2-7.92,6.57-11.55,7.93-13.48,7.81-15.74,5-.79-4.75-1.7-5.77S7,82.55,7,82.55Z"
              fill="#c34300"
            />
            <path
              d="M9,84.47c-2.27-.11-.23-2,4.53-3.28S41.84,72,47.16,69s40.55-12.46,42-13.48,3.74.79,2.72,5.44-2.38,7.7-2,8.94-7.59.91-12.23,2.72S66.42,77.79,63.7,78.47,54,81.42,52,81.19s-6.57.23-12.23,2-7.93,6.57-11.55,7.93-13.48,7.81-15.74,5-.8-4.76-1.7-5.78S9,84.47,9,84.47Z"
              fill="#2fb2a2"
            />
            <path
              d="M9,84.47c-2.27-.11-.23-2,4.53-3.28S41.84,72,47.16,69,89.07,56.5,90.54,55.48"
              fill="none"
              stroke="#ff9c4e"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.13"
            />
            <path
              d="M8.07,87c0-.12.13-.14.21-.16l.31,0a4.3,4.3,0,0,1,.62,0,2,2,0,0,1,.31.07.11.11,0,0,1,.06.09s0,0,0,0a.54.54,0,0,0,.12.09,2.7,2.7,0,0,0,.55.24,2,2,0,0,0,2.22-.47,3.51,3.51,0,0,1,2.13-1.19,8.79,8.79,0,0,1,2.45-.15,10.52,10.52,0,0,0-2.44.23A3.39,3.39,0,0,0,12.59,87a2.12,2.12,0,0,1-2.32.46,2.41,2.41,0,0,1-.57-.25l-.13-.1A.24.24,0,0,1,9.52,87l0,0a1.38,1.38,0,0,0-.29-.08,6,6,0,0,0-.61-.06h-.3C8.2,86.86,8,86.87,8.07,87Z"
              fill="#682402"
            />
            <path
              d="M7,82.49c-.14-.49.29-.91.69-1.12A6.86,6.86,0,0,1,9,80.87a24.78,24.78,0,0,0,2.73-.69c1.79-.58,3.56-1.26,5.33-1.88-1.74.71-3.51,1.37-5.29,2-.89.33-1.85.43-2.75.67a6.68,6.68,0,0,0-1.32.47C7.33,81.62,6.89,82,7,82.49Z"
              fill="#682402"
            />
            <path
              d="M9.22,92.17a1.3,1.3,0,0,1,.64-.32.58.58,0,0,1,.58.4,1.58,1.58,0,0,0,.38.58.64.64,0,0,0,.64,0,9.77,9.77,0,0,1,1.33-.55,2,2,0,0,1,1.42.09,2.23,2.23,0,0,0-1.4,0A9.56,9.56,0,0,0,11.5,93a.76.76,0,0,1-.73-.06,1.83,1.83,0,0,1-.4-.62c-.09-.22-.26-.42-.5-.39A1.33,1.33,0,0,0,9.22,92.17Z"
              fill="#682402"
            />
            <path
              d="M89.86,69.86A4.41,4.41,0,0,1,90,67.92,63.31,63.31,0,0,0,77.85,70c-4.82,1.3-8.09,3.34-13.6,5.66S58.43,79.89,52,80.34s-14.27,1-21.95,6.2S22.87,90.87,18.5,93c-2.59,1.25-4.95.76-7.36-.82a5.7,5.7,0,0,0,1.37,4c2.26,2.83,12.12-3.63,15.74-5S34.14,85,39.8,83.23,50.11,81,52,81.19s8.95-2,11.67-2.72S73,74.39,77.63,72.58,90.2,71.11,89.86,69.86Z"
              fill="#05a595"
            />
          </g>
          <g>
            <path
              d="M12.51,51.82c-2.31,1-4,10.41-2.6,16S79.92,50.31,79,47.5c-1.13-3.63-4-3.06-4-3.06s7.73-1.18,7.13-3.51-1.47-2.27-1.47-2.27,13.26-7,13.14-10S47.47,37.06,12.51,51.82Z"
              fill="#a93f00"
            />
            <path
              d="M13.58,53.86c-2.21,1-3.85,10.41-2.49,16s66.14-19.65,66.14-22-3.17-3.29-3.17-3.29,7.48-1.49,6.91-3.83-1.59-2.23-1.59-2.23,12.35-4.88,12.23-7.86S47.11,39.09,13.58,53.86Z"
              fill="#d33c80"
            />
            <path
              d="M13.78,51.79c1.81-.65,64.43-24.35,77.83-22.53"
              fill="none"
              stroke="#ff9c4e"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="1.13"
            />
            <path
              d="M9.9,57.59a1.59,1.59,0,0,1,1.45.74A2.84,2.84,0,0,0,9.9,57.59Z"
              fill="#682402"
            />
            <path
              d="M9.44,61.48a.71.71,0,0,1,0-.25.15.15,0,0,1,.08-.11.16.16,0,0,1,.15,0,2.69,2.69,0,0,1,.32.38.36.36,0,0,0,.38.17,1.08,1.08,0,0,0,.43-.21.78.78,0,0,1-.41.28.47.47,0,0,1-.49-.17,2.42,2.42,0,0,0-.27-.39C9.52,61.09,9.46,61.35,9.44,61.48Z"
              fill="#682402"
            />
            <path
              d="M9.44,64.58l1.16.34h0a4,4,0,0,0,3.46.36c1.17-.29,2.3-.76,3.45-1.12a35.69,35.69,0,0,1,3.5-1A8.32,8.32,0,0,1,24.63,63a5.5,5.5,0,0,0-1.81,0,13.56,13.56,0,0,0-1.78.32,34.7,34.7,0,0,0-3.48,1c-1.15.37-2.29.81-3.47,1.11a4,4,0,0,1-3.5-.42h0Z"
              fill="#682402"
            />
            <path
              d="M10.92,54c0,.15.22.23.34.33a3,3,0,0,0,.42.26l.43.24a1.38,1.38,0,0,0,.43.15v0c1.31-.34,2.6-.73,3.92-1s2.71.23,4,.23a4.56,4.56,0,0,0,1.87-.68l1.77-1,3.53-2c-1.16.69-2.31,1.39-3.49,2l-1.77,1a4.51,4.51,0,0,1-1.91.7c-1.36,0-2.68-.46-4-.24s-2.61.67-3.92,1v0c-.21.06-.33-.08-.49-.13l-.43-.25a3.62,3.62,0,0,1-.41-.27C11.13,54.21,11,54.13,10.92,54Z"
              fill="#682402"
            />
            <path
              d="M10.77,68.1c.08.63.19,1.23.32,1.8,1.36,5.63,66.14-19.65,66.14-22a2.52,2.52,0,0,0-.48-1.48c-9.41,2.62-29.2,10.65-39,15.34C28.79,66,17.65,67.33,10.77,68.1Z"
              fill="#b7115d"
            />
          </g>
          <path
            d="M16.75,87.59c-.9-.8.46-1,1.59-1.81s1.13-3.06,2.27-3.63,1.13,1.93,1.92,2,3.4.45,3.06,1.59-1.93.22-1.13,1.81.45,3.51-1.25,2.15-.68-1-2.15.45-1.7,1-1.7-1.58Z"
            fill="#c0e9c5"
          />
          <path
            d="M78.82,110.58s1-6.34,4.07-7.36c.34-.23-2.6-1-4.07,0"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.02"
          />
          <path
            d="M82.21,99.14s-.22,2.6.68,3.62"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.02"
          />
          <path
            d="M86.07,99.93s-2.84.34-3.18,2.83"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.02"
          />
          <path
            d="M86.07,106.61s-1.25-3.85-3.18-3.85c-2.56,0,4.08,1.14,4.08,1.14"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.02"
          />
          <path
            d="M82.89,107.29s1.93-3.62,0-4.07"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.02"
          />
          <path
            d="M87,102s-2.55-.85-4.14.73"
            fill="none"
            stroke="#f7f00f"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="1.02"
          />
          <text
            transform="matrix(0.95, -0.32, 0.32, 0.95, 27.7, 61.77)"
            fontSize="14.97"
            fill="#ffde00"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            <tspan letterSpacing="0em">W</tspan>
            <tspan x="12.59" y="0">
              h
            </tspan>
            <tspan x="20.9" y="0" letterSpacing="0em">
              a
            </tspan>
            <tspan x="28.05" y="0" letterSpacing="0.02em">
              t
            </tspan>
            <tspan x="33.32" y="0" letterSpacing="-0.07em">
              ’
            </tspan>
            <tspan x="35.34" y="0">
              s
            </tspan>
          </text>
          <text
            transform="translate(51.88 79.87) rotate(-18.29)"
            fontSize="17"
            fill="#c0e9c5"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            n
            <tspan x="9.43" y="0" letterSpacing="0em">
              e
            </tspan>
            <tspan x="17.9" y="0" letterSpacing="0.01em">
              x
            </tspan>
            <tspan x="25.99" y="0" letterSpacing="0em">
              t
            </tspan>
          </text>
          <text
            transform="translate(26.9 110.45)"
            fontSize="18.01"
            fill="#ffb0ec"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            <tspan letterSpacing="-0.01em">r</tspan>
            <tspan x="5.71" y="0">
              oom
            </tspan>
          </text>
          <text
            transform="translate(41.44 145.05)"
            fontSize="23.55"
            fill="#ffde00"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            ?
          </text>
        </g>
        <g opacity="0.28">
          <path
            d="M146.92,111s-40.95,24-58.21,31-36.6,19-37.62,21,8.82,6.64,9.49,6.28,27.66-17.73,34.17-20.1,59.59-33.36,59.59-33.36L146.93,111Z"
            fill="#531063"
          />
          <polygon
            points="146.92 110.95 146.92 110.95 146.93 110.96 146.92 110.95"
            fill="#531063"
          />
          <polygon
            points="146.92 110.95 146.92 110.95 146.93 110.96 146.92 110.95"
            fill="#531063"
          />
          <path
            d="M146.92,111s-40.95,24-58.21,31-36.6,19-37.62,21,8.82,6.64,9.49,6.28c.11-.05.88-.54,2.12-1.32-2.24-2.8-4.37-7.26-1.9-9.13,3.27-2.46,25.36-13,30.13-15.3s24.77-12.17,26.93-13.59c1.8-1.2,23.8-13.78,30.84-17.8L146.93,111Z"
            fill="#531063"
          />
          <path
            d="M141.57,116.18c1.8,1.14,6.47,3.27,6.47,3.27l3.41-1.76L141.28,114S139.77,115,141.57,116.18Z"
            fill="#531063"
          />
          <path
            d="M151.57,118.26a67,67,0,0,0,19,5.11c-12.06-7.53-25.12-13.17-38.11-18.84C134.6,108.44,141.68,113.7,151.57,118.26Z"
            fill="#531063"
          />
          <path
            d="M117,98c-6.6,1.51-6.88,2.57-5.19,3.68,1.41.94,10.46,3.6,19.79,2.51-4.71-2.06-9.42-4.14-14-6.31Z"
            fill="#531063"
          />
          <path
            d="M116.33,98.34c-6.6,1.5-6.88,2.57-5.19,3.68,1.44,1,10.85,3.72,20.39,2.44,1.87,4,9.12,9.42,19.37,14.16,6.69,3.09,13.41,4,19.65,4.75-16.83-10.68-34.82-17-52.72-25.38Z"
            fill="#531063"
          />
          <path
            d="M115.89,98.58c-6.61,1.5-6.89,2.56-5.2,3.68,1.44,1,10.85,3.72,20.39,2.44,1.87,4,9.12,9.42,19.38,14.16,7,3.25,13.69,3.84,20.09,4.51-16.91-10.85-34.5-16.88-52.55-25.3C117.35,98.24,116.64,98.41,115.89,98.58Z"
            fill="#531063"
          />
          <path
            d="M160.33,117.51a10.12,10.12,0,0,0-2.39.47,2.53,2.53,0,0,0-1.68,2.93l5.21-2.78Z"
            fill="#531063"
          />
          <path
            d="M150.18,118.36l.83-.49C149.42,118.35,150.18,118.36,150.18,118.36Z"
            fill="#531063"
          />
          <path d="M151,117.87l.21-.06a1,1,0,0,0,.63-.44Z" fill="#531063" />
          <path
            d="M152.18,113.41a1.25,1.25,0,0,0-.37.24c-.91,1,.55,2.82,0,3.72l3.81-2.26C154.5,114.54,153.35,114,152.18,113.41Z"
            fill="#531063"
          />
          <path
            d="M151.13,111.79l-1,.56C150.77,112.24,151.05,112,151.13,111.79Z"
            fill="#531063"
          />
          <path
            d="M150,112.37a5.93,5.93,0,0,1-.68.06c-3,.14-5.44-.57-5.49.46a6.08,6.08,0,0,0,.83,2.54l5.41-3Z"
            fill="#531063"
          />
          <path d="M150.13,112.35l-.16,0,.07,0Z" fill="#531063" />
          <path
            d="M142.28,108.86l-5.08,1.92a12.73,12.73,0,0,0,5.57-.09c1-.34,1-.74.89-1.22Z"
            fill="#531063"
          />
          <path
            d="M143.4,108.43l-1.12.43,1.38.61A3.45,3.45,0,0,1,143.4,108.43Z"
            fill="#531063"
          />
          <path
            d="M136.62,106.36l-3,1.29a19.78,19.78,0,0,0,4-.35,6.81,6.81,0,0,0,.72-.18Z"
            fill="#531063"
          />
          <path
            d="M139.09,105.29l-2.47,1.07,1.74.76C139.53,106.74,138.83,106.29,139.09,105.29Z"
            fill="#531063"
          />
          <path
            d="M140.85,100.3l.79-.29A7.47,7.47,0,0,0,140.85,100.3Z"
            fill="#531063"
          />
          <path
            d="M133.29,103a11.68,11.68,0,0,0-2.93.61l.56.25Z"
            fill="#531063"
          />
          <path
            d="M128.49,104.74l2.43-.87-.56-.25A5.21,5.21,0,0,0,128.49,104.74Z"
            fill="#531063"
          />
          <path
            d="M121.51,102.7c-2,1.88-.82,1.82-.82,1.82l4.37-2.41C123.84,101.85,122.61,101.63,121.51,102.7Z"
            fill="#531063"
          />
          <path
            d="M125.88,101.65l-.82.46a6.16,6.16,0,0,0,2.35.22Z"
            fill="#531063"
          />
          <path
            d="M113.9,100.83a11,11,0,0,0-2.38,1.45l3.25-1.72A3.75,3.75,0,0,0,113.9,100.83Z"
            fill="#531063"
          />
          <path
            d="M118.79,98.44l-4,2.12c1.64-.36,4.56-.53,6.29-1.08Z"
            fill="#531063"
          />
          <path
            d="M156,118.65c-7.27-3.46-16.79-8.86-21.22-13.1l-5.62-2.46c-6-.29-13-.35-14.34-2.11-1.07-1.4.46-2.17,1.65-2.54l-.57.14c-6.61,1.5-6.89,2.56-5.2,3.68,1.44,1,10.85,3.72,20.39,2.44,1.87,4,9.12,9.42,19.38,14.16,7,3.25,13.69,3.84,20.09,4.51-1.09-.7-.77-.48-1.88-1.14C163.89,121.33,159.13,120.15,156,118.65Z"
            fill="#531063"
            opacity="0.46"
          />
          <path
            d="M116.46,98.44c.4-.09.81-.18,1.17-.28C117.63,98.17,117.1,98.25,116.46,98.44Z"
            fill="#531063"
            opacity="0.46"
          />
          <polygon
            points="117.64 98.17 117.64 98.17 117.64 98.17 117.64 98.17"
            fill="#531063"
            opacity="0.46"
          />
          <path
            d="M132.88,103.34c-1.14-.11-2.41-.18-3.73-.25l5.62,2.46A12.14,12.14,0,0,1,132.88,103.34Z"
            fill="#531063"
            opacity="0.46"
          />
          <polygon
            points="90.76 140.66 78.93 146.31 89.31 151.76 100.78 145.66 90.76 140.66"
            fill="#531063"
            opacity="0.72"
          />
          <polygon
            points="71.31 151.19 59.48 156.85 65.56 159.1 69.66 163.59 81.33 156.19 71.31 151.19"
            fill="#531063"
            opacity="0.72"
          />
          <g>
            <path
              d="M68.31,142.75c-2.76.94-15.69,5.19-14.68,7.82S66.06,157.2,68.32,159s7,7.38,10.43,6.91,19.76-6.76,16.92-9S70.89,141.88,68.31,142.75Z"
              fill="#531063"
            />
            <path
              d="M80.26,165.54c-.49-1.3-11.44-9.36-15.72-11.57a71.54,71.54,0,0,1-9-5.88c-1.36.88-2.17,1.74-1.89,2.48,1,2.62,12.43,6.63,14.69,8.39s7,7.38,10.43,6.91a12.68,12.68,0,0,0,1.51-.33Z"
              fill="#531063"
            />
            <path
              d="M69,142.38c-2.73,1-15.5,5.32-14.69,7.82s11.6,6.08,13.67,7.72,6.26,6.91,9.64,6.39,19.53-6.92,16.92-9S71.51,141.49,69,142.38Z"
              fill="#531063"
            />
            <path
              d="M69.42,142.69c2.2.38,18.71,7.14,26.71,14.4Z"
              fill="#531063"
            />
            <path
              d="M77.59,164.31c.18,0,1-.22,1.2-.28-1.77-2.17-3.77-4.61-5.28-6.88-3-4.46-7.63-4-11.88-5.2-3.32-.95-6-1.49-5.93-3.79-1,.74-1.61,1.44-1.42,2,.81,2.49,11.6,6.08,13.67,7.72S74.21,164.83,77.59,164.31Z"
              fill="#531063"
            />
          </g>
          <g>
            <path
              d="M62.53,132.74c-4.48-4.65,2.79-3.58,22.53-4.21,10.36,4.9,53.53,33.77,55.65,37.94-5,2.29-21.83-5.39-30.43-5.38s-13.76-8.41-18.71-10.89S62.53,132.74,62.53,132.74Z"
              fill="#531063"
            />
            <path
              d="M64,132c-1.62-1.34.14-3.73,19.88-4.37,10.37,4.91,52.63,34,54.76,38.15-5,2.3-18.29-5.44-26.89-5.44S97.94,151.93,93,149.45,64,132,64,132Z"
              fill="#531063"
            />
            <path d="M84.21,127.7s45.25,27.75,54.38,38.07Z" fill="#531063" />
            <path
              d="M113.91,161.42s1.87-.64,1.38-.73-.35-.25-3.24-1.37a12.92,12.92,0,0,1-5.12-3.39Z"
              fill="#531063"
            />
            <path d="M134,166c-.36-1.12-1.35-1.33-3.63-2.4Z" fill="#531063" />
            <path
              d="M100.38,153A119.26,119.26,0,0,0,84.6,142c-5-2.8-6.67-5.18-10.31-5.9-2.7-.53-7.73-3.79-8.85-6.39-2.27.8-2.25,1.67-1.49,2.3,0,0,24.08,15,29,17.46s10.12,10.89,18.72,10.88a18,18,0,0,1,1.9.11C108.71,158,102,154.47,100.38,153Z"
              fill="#531063"
            />
            <path
              d="M78.35,138.73c-1.25-1.63-2.91-1.84-5.36-3.55s-4.57-2.14-6.79-3.7-1.47-1.51-1.29-1.61-1-.64-2.66-.26Z"
              fill="#531063"
            />
          </g>
          <polygon
            points="125.93 122.91 116.39 127.99 126.98 131.76 135.18 126.88 125.93 122.91"
            fill="#531063"
            opacity="0.72"
          />
          <polygon
            points="114.78 128.88 105.24 133.96 115.83 137.73 124.03 132.85 114.78 128.88"
            fill="#531063"
            opacity="0.72"
          />
          <g>
            <path
              d="M83.42,117.55c-1.45-1.06,1.19-.82,5.23.87s25.17,9.47,30.77,10.78S155,143,156.68,143.29s2,2-1.74,3.12-6.67,1.63-7.26,2.22-5.73-3.08-10.06-4.52-11-3.2-13.28-4.18-8.52-3.33-9.68-4.27a41.43,41.43,0,0,0-9.6-4.76c-5-1.9-9.68-1.25-13-2.39s-14.25-3.3-13.92-5.31,2.59-2,2.65-2.78S83.42,117.55,83.42,117.55Z"
              fill="#531063"
            />
            <path
              d="M83.31,116c-1.45-1,1.19-.82,5.23.88s25.16,9.46,30.77,10.77,35.6,13.79,37.26,14.09,3.91,2.81.17,4-8.58.77-9.17,1.36-5.73-3.08-10.06-4.52c-4.13-1.38-10.84-3.13-13.28-4.18s-8.52-3.32-9.68-4.27a41.43,41.43,0,0,0-9.6-4.76c-5-1.9-9.68-1.25-13-2.39s-14.25-3.3-13.92-5.3,2.59-2,2.65-2.79S83.31,116,83.31,116Z"
              fill="#531063"
            />
            <path
              d="M83.42,117.55c-1.45-1.06,1.19-.82,5.23.87s25.17,9.47,30.77,10.78S155,143,156.68,143.29s2,2-1.74,3.12-6.67,1.63-7.26,2.22-5.73-3.08-10.06-4.52-11-3.2-13.28-4.18-8.52-3.33-9.68-4.27a41.43,41.43,0,0,0-9.6-4.76c-5-1.9-9.68-1.25-13-2.39s-14.25-3.3-13.92-5.31,2.59-2,2.65-2.78S83.42,117.55,83.42,117.55Z"
              fill="#531063"
            />
            <path
              d="M83.42,117.55c-1.45-1.06,1.19-.82,5.23.87s25.17,9.47,30.77,10.78,36.52,14.39,38.18,14.7Z"
              fill="#531063"
            />
            <path
              d="M81.14,118c.1-.17,1.13.64,1,.67s.51,1.34,2.24,1.33a7.92,7.92,0,0,1,3.81,1.54Z"
              fill="#531063"
            />
            <path
              d="M83.39,116c.59-.58,2.8.52,3.72,1S93,119,93,119Z"
              fill="#531063"
            />
            <path
              d="M78.51,120.34s1,.12.76.51-.21.39-.06.58.61.23,1.45.51a2,2,0,0,1,1.07.71Z"
              fill="#531063"
            />
            <path
              d="M147.68,148.63a3.87,3.87,0,0,1,1.39-.6,76.39,76.39,0,0,0-9.58-4.74c-4.12-1.7-7.67-2.45-12.92-4.1s-6.72-1.12-11.38-3.85-10.32-6-18.91-7.65a78.86,78.86,0,0,1-12-2.91c-2.58-.72-3.84-2-4.43-3.58a2.75,2.75,0,0,0-1.69,2c-.33,2,10.57,4.16,13.92,5.31s8,.49,13,2.39a41.43,41.43,0,0,1,9.6,4.76c1.16.94,7.39,3.29,9.68,4.27s8.95,2.73,13.28,4.18S147.09,149.22,147.68,148.63Z"
              fill="#531063"
            />
          </g>
          <g>
            <path d="M154.46,133.13l0,0Z" fill="#531063" />
            <path
              d="M107.29,107.68c-2.21-.69-9.57,1.85-12.31,4.46s58.85,25.19,60.11,23.81a1.68,1.68,0,0,0-.63-2.82l0,0,0,0c.36.18,6,3,7.1,1.94s.49-1.45.49-1.45,13.58,3.47,15.46,2.38S140.62,118.16,107.29,107.68Z"
              fill="#531063"
            />
            <path
              d="M106.67,108.88c-2.14-.65-9.45,1.92-12.24,4.5s57.62,22.73,59.16,21.91,0-2.58,0-2.58,6,2.83,7.18,1.76.4-1.49.4-1.49,11.55,3.81,13.44,2.72S139,118.71,106.67,108.88Z"
              fill="#531063"
            />
            <path
              d="M175.58,135.19c-7.85-6.63-65.76-26.37-67.42-26.95Z"
              fill="#531063"
            />
            <path d="M101.73,108.54s.62.45.5.9Z" fill="#531063" />
            <path
              d="M98.85,109.69c.24-.11.46-.14.32.21s.61.41.61.41Z"
              fill="#531063"
            />
            <path
              d="M96.81,110.78l.55.64c.2.71,1,1.3,3.09,2.09s6.54,2.28,7.7,3.5Z"
              fill="#531063"
            />
            <path
              d="M105.26,108.8s1.36.52,3,1.27,2.22,1.92,3.52,2.33,6.36,1.55,6.59,1.61l-13.61-6.29C104.62,107.73,105.11,108.83,105.26,108.8Z"
              fill="#531063"
            />
            <path
              d="M95.4,112.61a8.88,8.88,0,0,0-1,.77c-2.78,2.58,57.62,22.73,59.16,21.91a1.17,1.17,0,0,0,.65-.74c-8.08-3.29-26.73-9.34-36.47-12.1C109,119.94,100.56,115.42,95.4,112.61Z"
              fill="#531063"
            />
          </g>
          <path
            d="M86.62,122.11c-.09-.68,1-.15,2.26.07s2.78-.56,3.92-.25-.51,1.18,0,1.58,2,1.67,1,1.92-1.45-.78-2,.13-2,1.43-2.26.19.21-.66-1.75-.8-1.82-.41-.1-1.32Z"
            fill="#531063"
          />
          <path
            d="M113.42,158s4.86-1.77,7.6-.76c.38.08-1.09-1.52-2.75-1.82Z"
            fill="#531063"
          />
          <path d="M123.24,155.46s-1.86.81-1.92,1.57Z" fill="#531063" />
          <path d="M125.32,157.46a5.45,5.45,0,0,0-4-.43Z" fill="#531063" />
          <path
            d="M120.93,159.8s1.69-1.9.39-2.77c-1.73-1.14,2,2.23,2,2.23Z"
            fill="#531063"
          />
          <path d="M118.34,158.62s3.68-.41,2.68-1.43Z" fill="#531063" />
          <path d="M124.6,158.63a5,5,0,0,0-3.28-1.6Z" fill="#531063" />
          <text
            transform="matrix(1.36, 0.5, -0.65, 0.76, 111.14, 117.96)"
            fontSize="9.38"
            fill="#bf7bb2"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            <tspan letterSpacing="0em">W</tspan>
            <tspan x="7.89" y="0">
              h
            </tspan>
            <tspan x="13.09" y="0" letterSpacing="0em">
              a
            </tspan>
            <tspan x="17.58" y="0" letterSpacing="0.02em">
              t
            </tspan>
            <tspan x="20.88" y="0" letterSpacing="-0.07em">
              ’
            </tspan>
            <tspan x="22.14" y="0">
              s
            </tspan>
          </text>
          <text
            transform="matrix(1.35, 0.5, -0.66, 0.75, 115.44, 135.16)"
            fontSize="10.67"
            fill="#531063"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            n
            <tspan x="5.92" y="0" letterSpacing="0em">
              e
            </tspan>
            <tspan x="11.24" y="0" letterSpacing="0.01em">
              x
            </tspan>
            <tspan x="16.32" y="0">
              t
            </tspan>
          </text>
          <text
            transform="matrix(0.91, 0.6, -0.88, 0.47, 77.35, 133.95)"
            fontSize="13.42"
            fill="#531063"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            <tspan letterSpacing="-0.01em">r</tspan>
            <tspan x="4.26" y="0">
              oom
            </tspan>
          </text>
          <text
            transform="matrix(0.91, 0.6, -0.88, 0.47, 65.52, 153.33)"
            fontSize="17.56"
            fill="#531063"
            fontFamily="Snicker-Bold, sans-serif"
            fontWeight="600"
          >
            ?
          </text>
          <path
            d="M117.63,98.16s-.23-4,2.14-3.52,11.22,6.49,13.11,8.7c4.72-4.68,35.65,4.11,37.67,20Z"
            fill="#531063"
          />
        </g>
      </g>
      {/* Admin corner */}
      <g
        id="admin_x5F_corner"
        onClick={() => openLiteracyModal('/process-steps-admin')}
        cursor="pointer"
        transform="translate(30, 465)"
      >
        <g className="admin-corner-building">
          <linearGradient
            id="a"
            gradientUnits="userSpaceOnUse"
            x1="63.76"
            x2="64.66"
            y1="82.38"
            y2="196.72"
          >
            <stop offset="0" stopColor="#00ac90" />
            <stop offset=".09" stopColor="#009e87" />
            <stop offset=".37" stopColor="#00746c" />
            <stop offset=".63" stopColor="#005658" />
            <stop offset=".84" stopColor="#00444c" />
            <stop offset="1" stopColor="#003d48" />
          </linearGradient>
          <linearGradient
            id="b"
            x1="54.61"
            x2="55.61"
            xlinkHref="#a"
            y1="70.95"
            y2="196.64"
          />
          <linearGradient
            id="c"
            x1="72.9"
            x2="73.96"
            xlinkHref="#a"
            y1="63.52"
            y2="196.71"
          />
          <linearGradient
            id="d"
            x1="45.47"
            x2="46.57"
            xlinkHref="#a"
            y1="57.23"
            y2="196.45"
          />
          <linearGradient
            id="e"
            x1="36.32"
            x2="37.26"
            xlinkHref="#a"
            y1="77.24"
            y2="196.21"
          />
          <linearGradient
            id="f"
            x1="18.03"
            x2="18.96"
            xlinkHref="#a"
            y1="77.24"
            y2="195.22"
          />
          <linearGradient
            id="g"
            x1="27.17"
            x2="28.22"
            xlinkHref="#a"
            y1="63.52"
            y2="195.74"
          />
          <linearGradient
            id="h"
            x1="91.19"
            x2="92.4"
            xlinkHref="#a"
            y1="44.65"
            y2="196.62"
          />
          <linearGradient
            id="i"
            x1="72.9"
            x2="74.16"
            xlinkHref="#a"
            y1="36.65"
            y2="195.54"
          />
          <linearGradient
            id="j"
            x1="45.47"
            x2="46.73"
            xlinkHref="#a"
            y1="36.65"
            y2="195.54"
          />
          <linearGradient
            id="k"
            x1="8.88"
            x2="9.73"
            xlinkHref="#a"
            y1="88.1"
            y2="194.55"
          />
          <linearGradient
            id="l"
            x1="82.05"
            x2="82.95"
            xlinkHref="#a"
            y1="82.38"
            y2="196.68"
          />
          <path
            d="m63.76 112.91c-.57-17.15 10.29-26.87 9.15-28s-2.29-5.14-10.29 0-11.43 49.73-2.29 82.31a104.34 104.34 0 0 1 3.94 29.39q4 0 8.1.06c.16-1.69.34-3.16.54-4.3 1.71-9.73-8.57-62.31-9.15-79.46z"
            fill="url(#a)"
          />
          <path
            d="m54.62 101.48c-.57-17.15 10.29-26.87 9.14-28s-2.28-5.15-10.28 0-11.48 49.72-2.29 82.3a107.4 107.4 0 0 1 3.32 40.67q4 .09 8 .13c.34-6.51.73-12.38 1.3-15.65 1.67-9.72-8.62-62.31-9.19-79.45z"
            fill="url(#b)"
          />
          <path
            d="m72.91 94.05c-.57-17.15 10.29-26.87 9.15-28.05s-2.29-5.15-10.29 0-11.44 49.73-2.29 82.31c5.44 19.38 4.21 35.12 2.43 48.31h8.47c.45-9.25.88-18.66 1.68-23.16 1.71-9.68-8.58-62.27-9.15-79.41z"
            fill="url(#c)"
          />
          <path
            d="m45.47 87.76c-.57-17.15 10.29-26.87 9.15-28s-2.29-5.14-10.29 0-11.43 49.72-2.33 82.3c6.26 22.28 3.69 39.75 1.63 54.05q4.47.18 9 .29c.6-10.91 1-23.7 2-29.19 1.7-9.72-8.63-62.3-9.16-79.45z"
            fill="url(#d)"
          />
          <path
            d="m36.33 107.76c-.57-17.14 10.29-26.86 9.14-28s-2.28-5.15-10.29 0-11.43 49.72-2.28 82.31a104.61 104.61 0 0 1 3.81 33.73c2.62.14 5.24.25 7.86.35.25-3.7.53-6.84.9-8.93 1.72-9.72-8.57-62.31-9.14-79.46z"
            fill="url(#e)"
          />
          <path
            d="m18 107.76c-.57-17.14 10.29-26.86 9.14-28s-2.28-5.15-10.29 0-11.43 49.72-2.28 82.31a104.82 104.82 0 0 1 3.87 32.43c2.62.24 5.24.47 7.86.66.24-3.27.51-6 .84-7.94 1.76-9.72-8.53-62.31-9.14-79.46z"
            fill="url(#f)"
          />
          <path
            d="m27.18 94.05c-.57-17.15 10.29-26.87 9.15-28s-2.33-5.16-10.33-.05-11.43 49.73-2.29 82.31c5.29 18.69 4.29 33.98 2.67 46.85 2.77.21 5.54.38 8.32.53.44-8.93.86-17.85 1.63-22.19 1.67-9.72-8.58-62.31-9.15-79.45z"
            fill="url(#g)"
          />
          <path
            d="m91.2 75.18c-.57-17.14 10.29-26.86 9.15-28s-2.29-5.14-10.29 0-11.43 49.72-2.29 82.3c8.31 29.59 1.06 50.69.08 67.16l9.53-.06c1.31-10.68 1.56-34 3-41.94 1.68-9.72-8.61-62.31-9.18-79.46z"
            fill="url(#h)"
          />
          <path
            d="m69.48 193.5s6.29 4.58 8.57 0 2.29-37.15 4-46.87-8.58-62.3-9.15-79.45 10.29-26.86 9.15-28-2.29-5.14-10.29 0-11.43 49.72-2.28 82.3-.57 54.88 0 72.02z"
            fill="url(#i)"
          />
          <path
            d="m42 193.5s6.29 4.58 8.58 0 2.28-37.15 4-46.87-8.58-62.3-9.11-79.45 10.29-26.86 9.15-28-2.29-5.14-10.29 0-11.43 49.72-2.33 82.3-.53 54.88 0 72.02z"
            fill="url(#j)"
          />
          <path
            d="m18 90.62c-1.15-1.15-2.29-5.15-10.29 0s-11.43 49.73-2.29 82.31a104.7 104.7 0 0 1 3.65 20.59q4.55.54 9.11 1c-.24-15.27-8.81-60.25-9.33-75.86-.53-17.18 10.33-26.9 9.15-28.04z"
            fill="url(#k)"
          />
          <path
            d="m82.06 112.91c-.58-17.15 10.28-26.91 9.14-28.01s-2.29-5.14-10.29 0-11.43 49.73-2.28 82.31a104.33 104.33 0 0 1 3.93 29.45h8.1c.16-1.68.34-3.13.54-4.26 1.72-9.76-8.57-62.34-9.14-79.49z"
            fill="url(#l)"
          />
          <path
            d="m80.42 147.54a29 29 0 0 1 16.12-14.61c10.91-4.2 27.2-8.56 32.9-14.1s10.92-8.4 15.95-16.29 7.06-5.54 10.25-10.54c2.86-4.52 12.25-34.08-21.83-32.57-3.19 2-6.55 15.79-17.12 19.65s-24.85 10.92-33.41 16.92-12.76 19.48-9.41 36.94 6.55 14.6 6.55 14.6z"
            fill="#ffecbf"
          />
          <path
            d="m130.28 103.55c-15.2 0-32.12 12.61-46 27.7-2.52 2.74-9.57-11-11.58-7.55 1.85 25 7.72 23.84 7.72 23.84a29 29 0 0 1 16.12-14.61c10.91-4.2 27.2-8.56 32.9-14.1s10.92-8.4 15.95-16.29 7.06-5.54 10.25-10.54c1.37-2.17 4.26-10.12 3.1-17.63-5.1 11.57-18.63 29.18-28.46 29.18z"
            fill="#dcb4b5"
            opacity=".61"
          />
          <path
            d="m73.79 234.33c.17-8.05-4.87-52 19.14-63.29s56.24-10.91 72.19-27 28.71-19 39.29-18.47 36.43 18.3 40 45.5-26.1 42-30.3 43.82c-3.72 1.63-24.76 9.4-47.93 5.37s-49-3.86-63.8 1.34-21.82 12.76-25.18 12.76z"
            fill="#ffecbf"
          />
          <path
            d="m79.25 186.15c3-5.37 16.78-22.5 36.93-23.5s31.9-5.38 41.47-12.43 25.35-18.13 26.35-22.16 5-17.46-4.37-26.86-23.17-14.78-33.57 0-21.83 17.46-29.55 18.3-32.51 15.28-37.26 30.72-6.38 21.49-3.7 31.23 3.7 4.7 3.7 4.7z"
            fill="#ffecbf"
          />
          <path
            d="m201 209.32c-9 .73-53.06-8.06-71.86-6.55s-43.14 13.6-55.35 31.23v.36h3.36c3.36 0 10.41-7.55 25.18-12.76s40.63-5.37 63.8-1.34 44.2-3.77 47.93-5.37c3.53-1.51 26-11.09 30-32.25-12.89 15.11-32.69 25.84-43.06 26.68z"
            fill="#be969c"
          />
          <g opacity=".35">
            <path
              d="m101.24 149.38a4.22 4.22 0 0 1 .23 1.53 5.58 5.58 0 0 1 -.17 1.42 6.26 6.26 0 0 1 -.49 1.35 4.34 4.34 0 0 1 -.91 1.24 4 4 0 0 1 -.24-1.52 5.71 5.71 0 0 1 .17-1.43 6 6 0 0 1 .5-1.34 4.2 4.2 0 0 1 .91-1.25z"
              fill="#192c3e"
            />
            <path
              d="m158.49 218.89c-.6-1.33-1.91-1.61-3.14-1.66a20.16 20.16 0 0 0 -3.84.31c-2.58.45-5.16 1.06-7.76 1.69l-3.92.93-2 .44a2.67 2.67 0 0 0 -1.2.49 1.1 1.1 0 0 0 -.31 1 5.32 5.32 0 0 0 .51 1.69 24.2 24.2 0 0 0 2 3.49 12.43 12.43 0 0 1 -3.19-2.75 6.76 6.76 0 0 1 -1.14-2 3.36 3.36 0 0 1 -.17-1.37 2.92 2.92 0 0 1 .55-1.48 4.5 4.5 0 0 1 2.28-1.49l1.94-.63c1.31-.41 2.63-.77 4-1.1a36.45 36.45 0 0 1 8.25-1.12 14.58 14.58 0 0 1 4.27.53 5.54 5.54 0 0 1 2 1.07 2.53 2.53 0 0 1 .87 1.96z"
              fill="#85c9e7"
            />
            <g fill="#192c3e">
              <path d="m108.63 132.59a11.46 11.46 0 0 0 -7.19 3.57 10.59 10.59 0 0 0 0 14.36 11.44 11.44 0 0 0 7.18 3.56 10.21 10.21 0 0 1 -8-2.73 10.86 10.86 0 0 1 -2.62-3.63 11.16 11.16 0 0 1 -.91-4.38 11 11 0 0 1 3.48-8 10.22 10.22 0 0 1 8.06-2.75z" />
              <path d="m108.63 139.48a3.56 3.56 0 0 1 3.26.76 4.27 4.27 0 0 1 0 6.53 3.57 3.57 0 0 1 -3.26.77 4.12 4.12 0 0 0 0-8.06z" />
            </g>
          </g>
          <path
            d="m92 206.13c-7.06-16.62-2.86-17.63 0-28.37a37.93 37.93 0 0 0 -7.48-.33c-14.31 16.37-10.6 50-10.74 56.9h3.36c3.36 0 10.41-7.55 25.18-12.76 1.07-.37 2.2-.72 3.38-1-4.23-2.93-10.51-6.94-13.7-14.44z"
            fill="#ff70ac"
            opacity=".32"
          />
          <path
            d="m149.59 97.05a44.42 44.42 0 0 1 -15 17.19 42.08 42.08 0 0 1 -10.54 5.26 32.55 32.55 0 0 1 -5.92 1.4l-.36.06h-.24a3.68 3.68 0 0 0 -.5.1c-.35.07-.73.19-1.12.3-.77.24-1.56.53-2.36.86-1.6.64-3.2 1.39-4.78 2.21s-3.16 1.67-4.71 2.58a104.44 104.44 0 0 0 -9 5.92 73.26 73.26 0 0 0 -8.24 7 35.83 35.83 0 0 0 -6.6 8.74 26.15 26.15 0 0 1 4.28-10.6 50.45 50.45 0 0 1 7.5-8.79 68.37 68.37 0 0 1 9-7.14 59.19 59.19 0 0 1 10.28-5.52c.93-.37 1.88-.71 2.89-1 .51-.15 1-.29 1.59-.4a6.76 6.76 0 0 1 .87-.16l.77-.1a31.67 31.67 0 0 0 5-1 49.19 49.19 0 0 0 9.77-3.84 69.88 69.88 0 0 0 17.42-13.07z"
            fill="#be969c"
          />
          <path
            d="m75.72 100.69c3.67 3.39 18.28-10.69 25.69-12.25s25.52-13.26 29.59-25.69-7.06-20.82-15.28-18.13-8.4 10.91-18 14.27-25.19 10.91-26.2 20.48-.16 17.3 4.2 21.32z"
            fill="#ffecbf"
          />
          <path
            d="m72.36 72.49c4.15.89 9.74-11.75 16.62-11.42s23.84-9.9 24.68-18.8-7.22-19.48-13.26-17.46-6.72 10.24-13.93 13.6-18.3 8.73-19.31 15.59-1.85 17 5.2 18.49z"
            fill="#ffecbf"
          />
          <path
            d="m131 62.75a15 15 0 0 0 0-10.08c-2.72 7.69-10.79 17.58-18.52 21.58-7.55 3.92-23.7 8.8-34 20.07-1.54 1.68-7.07-10-8.23-7.9 1 9.74 4.42 13.24 5.54 14.27 3.6 3.39 18.21-10.69 25.62-12.25s25.52-13.26 29.59-25.69z"
            fill="#dcb4b5"
            opacity=".61"
          />
          <path
            d="m70.18 49c2.35-5.55 11.92-5.71 18.3-9.07s8.52-12.77 3.19-22.68 1.51-16.11-3.19-17.12-3 3.86-8.73 14.61-6.38 9.26-9.57 17.79a24.81 24.81 0 0 0 0 16.47z"
            fill="#ffecbf"
          />
          <path
            d="m187.37 221.07s-11.92-72.19 17.29-71.69 24.85 56.62 24.85 56.62-18.64 14.23-42.14 15.07z"
            fill="#ff70ac"
          />
          <path
            d="m186.86 221.07a134.06 134.06 0 0 1 -3.27-20.13 128.28 128.28 0 0 1 -.29-20.47c.57-6.82 1.62-13.76 4.57-20.15a21.59 21.59 0 0 1 6.4-8.33 13.73 13.73 0 0 1 4.75-2.28 14.42 14.42 0 0 1 5.14-.33 16.54 16.54 0 0 0 -4.88 1.12 13.69 13.69 0 0 0 -4.07 2.63 21.58 21.58 0 0 0 -5.17 8.12 49.76 49.76 0 0 0 -2.54 9.53 90.86 90.86 0 0 0 -1.19 9.91c-.28 3.33-.38 6.68-.43 10s0 6.72.06 10.09c.17 6.76.51 13.51.92 20.29z"
            fill="#fff"
          />
          <path
            d="m228.5 206.13a53 53 0 0 1 -9.3 6.62 68.92 68.92 0 0 1 -10.37 4.85c-1.79.68-3.63 1.21-5.46 1.76-.93.25-1.87.45-2.79.67l-1.4.32-1.42.23a48.45 48.45 0 0 1 -11.4.66c3.75-.66 7.46-1.21 11.08-2.2a97.24 97.24 0 0 0 10.69-3.33c3.51-1.28 7-2.74 10.35-4.34s6.72-3.37 10.02-5.24z"
            fill="#c9417f"
          />
          <path
            d="m229.17 206.13c-.45-5.73-.92-11.38-1.61-17a124.52 124.52 0 0 0 -3-16.47 57.25 57.25 0 0 0 -2.61-7.81 34.05 34.05 0 0 0 -3.9-7.08 21 21 0 0 0 -5.87-5.43 22.27 22.27 0 0 0 -7.83-2.81 18.14 18.14 0 0 1 8.67 1.11 20.25 20.25 0 0 1 7.35 5.21 30.52 30.52 0 0 1 4.91 7.5 45.76 45.76 0 0 1 3 8.32 74.41 74.41 0 0 1 2.3 17.25 78 78 0 0 1 -1.41 17.21z"
            fill="#c9417f"
          />
          <path
            d="m197.61 135.78s16.45-13.43 31.81 13.52c-5 5.71-11.16-6.47-18.21-5.12s-14.11-2.69-13.6-8.4z"
            fill="#fff"
          />
          <circle
            cx="151.56"
            cy="185.18"
            fill="#d4e5f4"
            opacity=".72"
            r="14.06"
            stroke="#db4fcb"
            strokeMiterlimit="10"
            strokeWidth="3.36"
          />
          <path
            d="m92.09 171.71a80.24 80.24 0 0 1 13.91-6.71c4.83-1.84 9.77-3.37 14.68-4.8 9.82-2.87 19.71-5.27 28.66-9.23a44.76 44.76 0 0 0 12.11-7.54c.83-.73 1.86-1.71 2.8-2.58s2-1.75 3-2.59a68.22 68.22 0 0 1 6.34-4.73 49 49 0 0 1 14.41-6.66 36.8 36.8 0 0 1 15.57-.66 46 46 0 0 0 -14.57 3.47 55.29 55.29 0 0 0 -12.58 7.68c-1 .78-1.93 1.52-2.84 2.37s-1.87 1.62-2.75 2.49-1.8 1.71-2.66 2.61-1.68 1.72-2.71 2.74a41.39 41.39 0 0 1 -6.46 5.1 55.46 55.46 0 0 1 -7.13 3.79 95.25 95.25 0 0 1 -14.93 5c-5 1.28-10.06 2.32-15.07 3.3-10.07 1.98-19.99 3.78-29.78 6.95z"
            fill="#be969c"
          />
          <path
            d="m157.65 150.22c9.57-7.05 25.35-18.13 26.36-22.16.86-3.44 1.68-5.88 1-17.46-4.2 20.65-23.16 28.45-33.41 29.21-11.56.86-51.88 12.76-70.18 31.9-3.12 3.26-2.25-17.39-4.2-13.09.1.4-4.53 12.42-1.68 22.83 2.67 9.74 3.7 4.7 3.7 4.7 3-5.37 17-19.81 36.93-23.5s31.91-5.38 41.48-12.43z"
            fill="#dcb4b5"
            opacity=".61"
          />
          <path
            d="m159.2 102.4c.6-6 13.78.56 16.35 4.09s4.21 9.93 2.75 11.69-3.47 0-9.25-8c-2.58-3.53-10.4-2.26-9.85-7.78z"
            fill="#fff"
          />
          <path
            d="m132.8 60.4a7.75 7.75 0 0 0 -1.54 2.78c-.39 1-.74 2-1.1 3.05a52.91 52.91 0 0 1 -2.58 6.13 24.62 24.62 0 0 1 -4 5.69 17.84 17.84 0 0 1 -6 4.19c-7.82 3.37-15.47 7.18-22.91 11.27-1.86 1-3.7 2.06-5.5 3.16-.91.53-1.78 1.09-2.67 1.64s-1.77 1.15-2.47 1.68a22.73 22.73 0 0 0 -6.83 9.16 41.91 41.91 0 0 0 -3 11.93 79.54 79.54 0 0 0 -.35 12.86 48.15 48.15 0 0 1 -2.59-12.94 37.54 37.54 0 0 1 1.54-13.49 25.44 25.44 0 0 1 7.68-12c.46-.39 1-.81 1.43-1.12l1.38-1c.92-.62 1.85-1.25 2.79-1.84 1.87-1.19 3.78-2.3 5.7-3.38a134.29 134.29 0 0 1 24.22-10.4c3.53-1 6.6-3.69 9.1-7a61.81 61.81 0 0 0 3.59-5.28c.59-.91 1.17-1.84 1.81-2.74a16.56 16.56 0 0 1 1.05-1.3 4.07 4.07 0 0 1 1.25-1.05z"
            fill="#be969c"
          />
          <path
            d="m116 44.62a15.54 15.54 0 0 0 -3.84 3.07 27.92 27.92 0 0 0 -2.83 3.93 39.36 39.36 0 0 1 -3 4.27 19.36 19.36 0 0 1 -4.2 3.74l-1.23.73c-.42.23-.86.42-1.29.62l-.65.3-.57.24-1.12.48c-1.49.66-3 1.32-4.42 2a85.49 85.49 0 0 0 -8.43 4.63 40.74 40.74 0 0 0 -3.82 2.69 26.6 26.6 0 0 0 -3.3 3 13.92 13.92 0 0 0 -2.3 3.42 9.11 9.11 0 0 0 -.58 1.79c-.13.72-.27 1.58-.38 2.37a53.81 53.81 0 0 0 -.67 9.62 16.39 16.39 0 0 0 2.71 9.17 11 11 0 0 1 -3.59-3.78 20.31 20.31 0 0 1 -2-4.93 39.35 39.35 0 0 1 -1.14-10.43c0-.89 0-1.7.08-2.64a13.82 13.82 0 0 1 .57-3.08 17.93 17.93 0 0 1 2.91-5.16 34.13 34.13 0 0 1 8.27-7.11 61.24 61.24 0 0 1 9.34-4.75c1.61-.65 3.23-1.26 4.88-1.78l1.24-.39.61-.19.52-.17c.34-.12.7-.21 1-.34l1-.44a18 18 0 0 0 3.72-2.39c1.18-1 2.31-2.16 3.53-3.35a24.26 24.26 0 0 1 4.07-3.36 12.21 12.21 0 0 1 4.91-1.78z"
            fill="#be969c"
          />
          <path
            d="m94.3 24.35c-8.25 8.65-15.13 11.23-19.08 11.37-2.37.09-3.63-2.65-3.9-6.08-.35.83-.72 1.77-1.14 2.89a24.81 24.81 0 0 0 0 16.46c2.35-5.55 11.92-5.71 18.3-9.07 4.82-2.54 7.24-8.52 5.82-15.57z"
            fill="#dcb4b5"
            opacity=".61"
          />
          <path
            d="m99.06 52.68c-5 2-17.13 4.44-24.54 11.49-4-3.72-.28-11.37 1.56-19.55 0 0-1.34.61-3.34 1.56-2.95 2.32-5.16 5-5.58 7.84a54 54 0 0 0 -.67 7.84 13.42 13.42 0 0 0 .76 5.62 6.74 6.74 0 0 0 5.11 5 1.9 1.9 0 0 0 .41 0h.14.28.17l.25-.06.19-.08.25-.1.2-.11.24-.14.21-.13.25-.17.21-.16.25-.19.22-.18.25-.23.23-.2.25-.24.23-.22c.09-.08.17-.17.26-.26l.24-.24.25-.26.25-.27.23-.24.3-.32c.67-.72 1.36-1.49 2.08-2.26 2.63-2.79 5.55-5.44 8.75-5.29 6.89.34 23.84-9.9 24.68-18.8 0-.2 0-.4 0-.59-5.22 5.38-9.83 9.01-14.57 10.94z"
            fill="#dcb4b5"
            opacity=".61"
          />
          <path
            d="m100.57 25.48a11.66 11.66 0 0 0 -3.31 4.31c-.79 1.6-1.51 3.33-2.49 5.11a17.18 17.18 0 0 1 -4.06 5c-.46.36-.92.71-1.4 1l-1.5.86-2.51 1.29c-3.33 1.62-6.65 3.13-9.79 4.83a34.72 34.72 0 0 0 -4.51 2.79 12.19 12.19 0 0 0 -3.66 4 9 9 0 0 1 1.42-6 20.37 20.37 0 0 1 4-4.7 42.38 42.38 0 0 1 9.93-6.41l2.63-1.19 1-.48c.32-.18.63-.39 1-.56a19.5 19.5 0 0 0 3.65-3.24 55.39 55.39 0 0 1 4-4.2 8.88 8.88 0 0 1 5.6-2.41z"
            fill="#be969c"
          />
          <path
            d="m140.36 64.1c2-2.81 14.27 2.51 14.27 10.24s-3.36-.17-7.22 2.68-10.07 17.98-14.61 11.42c-3.15-4.56 3.53-3.69 6.72-11.42 1.64-3.96-2.18-8.73.84-12.92z"
            fill="#fff"
          />
          <path
            d="m117.86 46.8c1.53-1.59 8.56 1.68 10.58 6.72s-5.21 1.68-6.72 3.52 1.85 8.4-8.06 11.42c-1-4.2 0-4.53 2.19-9.07s-1.85-8.56 2.01-12.59z"
            fill="#fff"
          />
          <path
            d="m103.42 29c1.39-2.32 8.9 7.38 6.89 12.59-2.52 1.68-7.56 8.22-12.6 7.39s5.54-4.87 6.55-7.39-2.85-9.23-.84-12.59z"
            fill="#fff"
          />
          <path
            d="m85.29 18.09c-3 1.35-2.69-4.87 0-10.07s1.85 2.69 2.35 5.2 3.53 4.2 2.52 4.87-4.87 0-4.87 0z"
            fill="#fff"
          />
          <g strokeMiterlimit="10">
            <path
              d="m143.63 177.84 17.46 12.93"
              fill="none"
              stroke="#f9f9f9"
              strokeLinecap="round"
              strokeWidth="2.52"
            />
            <path
              d="m141.28 181.53 16.96 12.43"
              fill="none"
              stroke="#f9f9f9"
              strokeLinecap="round"
              strokeWidth="2.52"
            />
            <path
              d="m151.52 171.12v28.21"
              fill="none"
              stroke="#db4fcb"
              strokeLinecap="round"
              strokeWidth="3.36"
            />
            <path
              d="m137.5 185.14h28.04"
              fill="none"
              stroke="#db4fcb"
              strokeLinecap="round"
              strokeWidth="3.36"
            />
            <circle
              cx="156.6"
              cy="121.9"
              fill="#d4e5f4"
              opacity=".72"
              r="10.13"
              stroke="#db4fcb"
              strokeWidth="2.42"
            />
            <path
              d="m150.89 116.61 12.57 9.31"
              fill="none"
              stroke="#f9f9f9"
              strokeLinecap="round"
              strokeWidth="1.81"
            />
            <path
              d="m149.19 119.27 12.22 8.95"
              fill="none"
              stroke="#f9f9f9"
              strokeLinecap="round"
              strokeWidth="1.81"
            />
            <path
              d="m156.57 111.78v20.31"
              fill="none"
              stroke="#db4fcb"
              strokeLinecap="round"
              strokeWidth="2.42"
            />
            <path
              d="m146.47 121.87h20.2"
              fill="none"
              stroke="#db4fcb"
              strokeLinecap="round"
              strokeWidth="2.42"
            />
            <circle
              cx="101.53"
              cy="105.97"
              fill="#d4e5f4"
              opacity=".72"
              r="8.86"
              stroke="#db4fcb"
              strokeWidth="1.51"
            />
            <path
              d="m96.54 101.35 10.99 8.14"
              fill="none"
              stroke="#f9f9f9"
              strokeLinecap="round"
              strokeWidth="1.01"
            />
            <path
              d="m95.06 103.67 10.68 7.83"
              fill="none"
              stroke="#f9f9f9"
              strokeLinecap="round"
              strokeWidth="1.01"
            />
            <path
              d="m101.51 97.12v17.76"
              fill="none"
              stroke="#db4fcb"
              strokeLinecap="round"
              strokeWidth="1.51"
            />
            <path
              d="m92.68 105.95h17.66"
              fill="none"
              stroke="#db4fcb"
              strokeLinecap="round"
              strokeWidth="1.51"
            />
          </g>
          <path
            d="m73.79 234.33h3.36c1.58 0 4-1.68 7.66-4-6.62-10.37-8.19-25.75-8.34-36.81-4.53 16.41-2.57 35.74-2.68 40.81z"
            fill="#beaa83"
          />
          <path
            d="m96.2 151.4c-9.73-1.51-20-4-21.15 0s-4.87 11.08 15.61 13.6c-2.52 12.42-6 35.09-11.58 40.63s-11.75 8.37-16.79 7.72-13.94-6.72-17-17.8c8.9-3.86 11.08-5.71 3-9.57s-13.93-10.24-15.78-7.89-6.54 20.82-7 23 8.06-1.51 11.59-3c2 5.2 8.89 22 20.81 28.37s17.8 22 16.46 26c3.69-1 10.41-13.94 28.87-13.94s29.89-.33 36.77-8.22c3 2.18 6.72 4.86 8.06 4s7.93-14.24 6.93-19.44-15.44-1-21 .5 1.34 7.89 1.34 7.89-5.54 4.7-12.59 5.21-29.55.67-24.51-20.65 11.39-39.81 11.39-39.81 13.44 5.37 19.65 1.34c3.58-2.32 2.52-10.24-4.54-11.58s-16.95-3.86-16.95-3.86l.84-4.71-11.08-3.35z"
            fill="#0e6c8b"
          />
          <path
            d="m45.84 195.55c1.21-.87 2.46-1.63 3.65-2.45.6-.4 1.19-.8 1.73-1.23a6.35 6.35 0 0 0 1.3-1.29.6.6 0 0 0 .14-.43.84.84 0 0 0 -.15-.27 4.72 4.72 0 0 0 -1.26-1 39.84 39.84 0 0 0 -3.71-1.93 43.54 43.54 0 0 1 -7.45-4.95c-1.16-.9-2.26-1.85-3.39-2.72a12.53 12.53 0 0 0 -1.7-1.14 1.62 1.62 0 0 0 -1.89 0 1.35 1.35 0 0 1 .92-.71 3.08 3.08 0 0 1 1.21 0 10.52 10.52 0 0 1 2.2.73 44.29 44.29 0 0 1 3.93 2.07c2.52 1.46 5 2.92 7.48 4.19a26.37 26.37 0 0 1 4 2.26 6.76 6.76 0 0 1 1.87 2 2.82 2.82 0 0 1 .38 1.81 3 3 0 0 1 -.77 1.53 10.57 10.57 0 0 1 -4.14 2.39 30.61 30.61 0 0 1 -4.35 1.14z"
            fill="#85c9e7"
          />
          <path
            d="m75.55 150.89c-.14 2.16-.55 4.29.14 5.89s2.17 2.65 3.88 3.51c.84.48 1.8.78 2.71 1.19l2.9 1c1 .28 2 .65 3 .95s2 .64 3 1.07a29 29 0 0 1 -3.22.15 26.28 26.28 0 0 1 -6.4-.9 18.57 18.57 0 0 1 -3.12-1.2l-.75-.39c-.25-.14-.49-.32-.73-.48l-.71-.52a6.5 6.5 0 0 1 -.66-.63 6.31 6.31 0 0 1 -1.78-3.21 6.5 6.5 0 0 1 .3-3.5 16.22 16.22 0 0 1 1.44-2.93z"
            fill="#192c3e"
          />
          <path
            d="m97.55 145.86a4.36 4.36 0 0 1 .23 1.52 5.71 5.71 0 0 1 -.17 1.43 5.57 5.57 0 0 1 -.5 1.34 4.2 4.2 0 0 1 -.91 1.25 4.22 4.22 0 0 1 -.23-1.53 5.58 5.58 0 0 1 .17-1.42 6.29 6.29 0 0 1 .5-1.35 4.16 4.16 0 0 1 .91-1.24z"
            fill="#192c3e"
          />
          <path
            d="m128.61 169.53c1.9-2.13 1.4-5 .2-7a7 7 0 0 0 -2.48-2.33 7.9 7.9 0 0 0 -1.58-.67l-.85-.21c-.31-.07-.67-.13-1-.19a75.42 75.42 0 0 1 -8-2.06 54.32 54.32 0 0 1 -7.75-3 72.25 72.25 0 0 1 8.25.85c2.72.41 5.41.91 8.08 1.44.34.07.65.12 1 .21l1.14.31a9.31 9.31 0 0 1 2.15 1.05 8.08 8.08 0 0 1 3 3.63 7.55 7.55 0 0 1 .47 4.56 4.78 4.78 0 0 1 -2.63 3.41z"
            fill="#85c9e7"
          />
          <path
            d="m109 168c3.5.25 6.73.9 10 1.32a43.34 43.34 0 0 0 4.79.46 16.64 16.64 0 0 0 4.9-.44 8.2 8.2 0 0 1 -4.73 2.41 16.06 16.06 0 0 1 -5.31.06 22.25 22.25 0 0 1 -5-1.31 17.86 17.86 0 0 1 -4.65-2.5z"
            fill="#192c3e"
          />
          <path
            d="m121.55 228.63a31.19 31.19 0 0 1 -9.93.83 22 22 0 0 1 -9.84-2.93 13.87 13.87 0 0 1 -4-3.64 12.58 12.58 0 0 1 -2.1-4.93 17.22 17.22 0 0 1 1.32-9.96 26.72 26.72 0 0 0 .83 9.42 12.27 12.27 0 0 0 5.41 6.7 27 27 0 0 0 8.65 3.16c3.11.62 6.37.98 9.66 1.35z"
            fill="#85c9e7"
          />
          <path
            d="m154.8 215.36c-.6-1.32-1.92-1.6-3.14-1.66a20.11 20.11 0 0 0 -3.84.32c-2.58.44-5.16 1.06-7.76 1.68l-3.92.93-2 .45a2.78 2.78 0 0 0 -1.2.48 1.09 1.09 0 0 0 -.3 1 5.47 5.47 0 0 0 .51 1.69 24.25 24.25 0 0 0 2 3.49 12.64 12.64 0 0 1 -3.15-2.74 6.71 6.71 0 0 1 -1.13-2 3.51 3.51 0 0 1 -.18-1.37 3 3 0 0 1 .56-1.47 4.44 4.44 0 0 1 2.28-1.5l1.94-.63c1.3-.41 2.62-.77 4-1.09a36.53 36.53 0 0 1 8.25-1.12 14.28 14.28 0 0 1 4.28.53 5.51 5.51 0 0 1 2 1.06 2.53 2.53 0 0 1 .8 1.95z"
            fill="#85c9e7"
          />
          <path
            d="m140 231c1.19.51 2.3 1.12 3.44 1.66a19.22 19.22 0 0 0 3.29 1.39 1.69 1.69 0 0 0 .36.06.73.73 0 0 0 .29 0h.13s0 0 0-.05 0 0 0 0l.1-.16.21-.33.43-.77c.56-1.07 1.11-2.18 1.63-3.29 1.05-2.24 2.07-4.5 3-6.79a25.24 25.24 0 0 0 2.06-7.12 9.57 9.57 0 0 1 .44 3.88 23.64 23.64 0 0 1 -.62 3.84 38.48 38.48 0 0 1 -2.59 7.26 33.65 33.65 0 0 1 -1.86 3.43 9.27 9.27 0 0 1 -1.4 1.77 1.85 1.85 0 0 1 -.82.44 2.24 2.24 0 0 1 -.8 0 3 3 0 0 1 -.65-.12 5.58 5.58 0 0 1 -.54-.2 13.68 13.68 0 0 1 -3.34-2.22 31.75 31.75 0 0 1 -2.76-2.68z"
            fill="#192c3e"
          />
          <path
            d="m75.55 252.47a5.75 5.75 0 0 0 1.75-1.3c.53-.51 1-1 1.53-1.59 1-1.09 2-2.17 3.11-3.21a34.16 34.16 0 0 1 7.27-5.37 30.49 30.49 0 0 1 8.6-3.08 33.28 33.28 0 0 1 4.55-.57c1.54-.08 3-.07 4.48-.09 3 0 5.88 0 8.81-.15s5.83-.28 8.71-.63a34.75 34.75 0 0 0 8.37-2.06 22.57 22.57 0 0 0 7.29-4.72 19.61 19.61 0 0 1 -6.76 5.85 30.89 30.89 0 0 1 -8.58 2.88 99.18 99.18 0 0 1 -17.82 1.34c-1.49 0-3 0-4.37 0s-2.84.24-4.25.44a32.64 32.64 0 0 0 -8.16 2.5 37.7 37.7 0 0 0 -7.35 4.55c-1.17.88-2.28 1.84-3.43 2.78-.57.46-1.15.94-1.76 1.37a5.88 5.88 0 0 1 -1.99 1.06z"
            fill="#192c3e"
          />
          <path
            d="m25.52 201.09a.45.45 0 0 0 .37.56 2.11 2.11 0 0 0 .75 0 11.22 11.22 0 0 0 1.51-.41c1-.33 2-.74 2.93-1.15 1.94-.83 3.83-1.76 5.74-2.66l.65-.31.31.71a92.52 92.52 0 0 0 7.93 14.8 56.2 56.2 0 0 0 5.09 6.55 34.31 34.31 0 0 0 6.21 5.3l3.64 2.24a33.24 33.24 0 0 1 3.44 2.79 35 35 0 0 1 5.56 6.72 35.9 35.9 0 0 1 3.77 7.77 26.55 26.55 0 0 1 1.07 4.19 8.85 8.85 0 0 1 -.11 4.28 9.3 9.3 0 0 0 -.48-4.15 32.45 32.45 0 0 0 -1.47-3.92 40.75 40.75 0 0 0 -4.25-7.18 37 37 0 0 0 -5.57-6.08 29.62 29.62 0 0 0 -3.26-2.46l-1.76-1-1.89-1.13a33.4 33.4 0 0 1 -6.7-5.7 51.64 51.64 0 0 1 -5.24-6.95 73.62 73.62 0 0 1 -7.3-15.57l1 .4c-2 .77-4 1.49-6 2.13-1 .31-2.05.6-3.1.81a8.65 8.65 0 0 1 -1.6.2 2.29 2.29 0 0 1 -.82-.11.51.51 0 0 1 -.42-.67z"
            fill="#192c3e"
          />
          <path
            d="m106.58 129.36a10.87 10.87 0 0 0 -1.63-.12 10.63 10.63 0 0 0 -6.36 2.09 10.35 10.35 0 0 0 -1.6 1.43s0 0 0 0a10.75 10.75 0 0 0 -2.76 6.24v.48.38s0 .37 0 .55a10.73 10.73 0 0 0 5.58 9c.23.13.47.25.71.36l.6.25a10.75 10.75 0 1 0 5.49-20.66zm-1.64 14.64a4 4 0 0 1 0-8.06 3.73 3.73 0 0 1 1.11.16l.22.07.24.09a4 4 0 0 1 .85.49l.26.22a2 2 0 0 1 .26.25 3.92 3.92 0 0 1 .9 1.54c0 .12.07.23.1.35s.05.25.06.38a3.71 3.71 0 0 1 0 .47 4 4 0 0 1 -4 4.04z"
            fill="#0e6c8b"
          />
          <path
            d="m115.34 140.82a21.73 21.73 0 0 0 -1.66-3.76 15.36 15.36 0 0 0 -2.32-3 15.64 15.64 0 0 0 -3-2.31 22.07 22.07 0 0 0 -3.76-1.66 8.83 8.83 0 0 1 10.74 10.74z"
            fill="#85c9e7"
          />
          <path
            d="m104.93 129.07a11.42 11.42 0 0 0 -7.18 3.56 10.58 10.58 0 0 0 0 14.36 11.46 11.46 0 0 0 7.18 3.57 10.21 10.21 0 0 1 -8-2.73 10.86 10.86 0 0 1 -2.57-3.63 11.39 11.39 0 0 1 -.92-4.39 11 11 0 0 1 3.49-8 10.23 10.23 0 0 1 8-2.74z"
            fill="#192c3e"
          />
          <path
            d="m104.93 136a3.59 3.59 0 0 1 3.27.77 4.27 4.27 0 0 1 0 6.53 3.59 3.59 0 0 1 -3.27.76 4.12 4.12 0 0 0 0-8.06z"
            fill="#192c3e"
          />
          <ellipse cx="220.27" cy="181.69" fill="#c9417f" rx="3.08" ry="5.72" />
        </g>
        <g className="text" transform="translate(90 20)">
          <path
            d="M23,238.84c-.5-.08-.76-.32-.76-.72s0-.63,0-.9a5,5,0,0,1,.07-.74.65.65,0,0,1,.24-.44.76.76,0,0,1,.44-.13c.16,0,.45,0,.85.06.4-1.23.83-2.45,1.29-3.65s.91-2.34,1.35-3.41a1.19,1.19,0,0,1,.85-.73,8.35,8.35,0,0,1,1-.15,8.51,8.51,0,0,1,1-.06h.47l.38,0a1.12,1.12,0,0,1,.9.64c.39.77.86,1.78,1.41,3s1.09,2.64,1.63,4.17l.47,0,.26,0H35a.64.64,0,0,1,.68.55,4,4,0,0,1,.13,1.11v.31a1.24,1.24,0,0,1,0,.33.84.84,0,0,1-.22.53,1,1,0,0,1-.49.19c.08.29.16.56.23.82l.18.69c0,.15.06.25.07.31s0,.1,0,.14a.58.58,0,0,1-.46.61,10.34,10.34,0,0,1-1.16.27,6.89,6.89,0,0,1-1.21.1.69.69,0,0,1-.51-.16,1,1,0,0,1-.27-.5l-.53-2c-.71,0-1.44.06-2.17.06l-1.38,0q-.69,0-1.35-.06c-.09.37-.17.72-.25,1.07s-.14.68-.2,1a.7.7,0,0,1-.74.64,6.44,6.44,0,0,1-1.16-.12,8.46,8.46,0,0,1-1.14-.26.6.6,0,0,1-.47-.62.62.62,0,0,1,0-.13c0-.05,0-.14,0-.27s.09-.44.16-.72S22.93,239.14,23,238.84ZM27.38,236h1.54l1.57,0c-.24-.77-.5-1.53-.77-2.28s-.58-1.48-.89-2.15c-.28.78-.53,1.53-.77,2.27S27.59,235.29,27.38,236Z"
            fill="#fff"
          />
          <path
            d="M43.85,241.57a1.73,1.73,0,0,1-.42-.1.44.44,0,0,1-.22-.18.72.72,0,0,1-.1-.27c0-.11,0-.24,0-.39a4.25,4.25,0,0,1-2.75,1,4.08,4.08,0,0,1-1.67-.33,3.55,3.55,0,0,1-1.26-.92,4.16,4.16,0,0,1-.8-1.37,5.27,5.27,0,0,1-.27-1.7,5.15,5.15,0,0,1,.43-2.14,5.09,5.09,0,0,1,1.17-1.66,5.54,5.54,0,0,1,1.69-1.08,5.23,5.23,0,0,1,2-.39,5.9,5.9,0,0,1,.91.08,3.14,3.14,0,0,1,.9.28c0-.69,0-1.33,0-1.92s0-1.08,0-1.46a2.53,2.53,0,0,1,0-.53.67.67,0,0,1,.12-.32.49.49,0,0,1,.24-.15,2.78,2.78,0,0,1,.37-.05l.27,0h.83a2.31,2.31,0,0,1,.49.05,1.23,1.23,0,0,1,.68.23q.21.18.21.84c0,.55,0,1.29,0,2.2s-.05,1.89-.09,2.94-.08,2.12-.15,3.21-.14,2.09-.24,3a1.39,1.39,0,0,1-.27.78,1.06,1.06,0,0,1-.7.3,2.05,2.05,0,0,1-.37,0h-.75A1.37,1.37,0,0,1,43.85,241.57Zm-.49-6.64-.57-.17a2.79,2.79,0,0,0-.68-.07,2.45,2.45,0,0,0-1,.21,2.57,2.57,0,0,0-.76.57,2.49,2.49,0,0,0-.48.77,2.31,2.31,0,0,0-.17.82,2,2,0,0,0,.39,1.3,1.48,1.48,0,0,0,1.23.48,2.84,2.84,0,0,0,2-.93Z"
            fill="#fff"
          />
          <path
            d="M56.42,233.33a4.16,4.16,0,0,1,1.36-1,3.78,3.78,0,0,1,1.54-.33,4.34,4.34,0,0,1,1.09.14,2.56,2.56,0,0,1,.93.47,2.29,2.29,0,0,1,.66.84,2.93,2.93,0,0,1,.25,1.25c0,.34,0,.73,0,1.19s0,.94-.08,1.46S62.07,238.4,62,239s-.12,1.13-.2,1.68a1.5,1.5,0,0,1-.18.59c-.09.19-.3.28-.63.28s-.42,0-.73-.05a7.23,7.23,0,0,1-.89-.14.75.75,0,0,1-.61-.83c0-.15,0-.63.11-1.43s.1-1.87.1-3.21a2.08,2.08,0,0,0-.11-.73.42.42,0,0,0-.42-.27,2.62,2.62,0,0,0-1.62.68c0,.22,0,.46,0,.7V237c0,.54,0,1.13,0,1.76s0,1.22-.06,1.75a1.29,1.29,0,0,1-.18.71.78.78,0,0,1-.65.23H55a2.93,2.93,0,0,1-.53,0,.65.65,0,0,1-.52-.28,1.21,1.21,0,0,1-.18-.64c0-.77,0-1.52,0-2.25s0-1.49-.1-2.28a1.75,1.75,0,0,0-.16-.69.4.4,0,0,0-.38-.25,1.81,1.81,0,0,0-.78.18,3.61,3.61,0,0,0-.69.46c0,.8,0,1.59.07,2.37s.1,1.55.17,2.33l0,.2a1.28,1.28,0,0,1,0,.19.6.6,0,0,1-.2.49,1.43,1.43,0,0,1-.8.21l-.29,0h-.65l-.29,0a1.07,1.07,0,0,1-.76-.26,1.43,1.43,0,0,1-.24-.68c-.1-1-.18-1.93-.24-2.9s-.1-2-.1-2.95V234c0-.23,0-.46,0-.69a3.54,3.54,0,0,1,.09-.73.52.52,0,0,1,.44-.38,5.06,5.06,0,0,1,.53-.1c.2,0,.41,0,.62-.06l.64,0,.55,0a.45.45,0,0,1,.38.13.64.64,0,0,1,.09.36,1.77,1.77,0,0,1,0,.23,1.38,1.38,0,0,1,0,.26,4,4,0,0,1,1.05-.61,3.07,3.07,0,0,1,1.14-.24,4.12,4.12,0,0,1,1.49.24A2.41,2.41,0,0,1,56.42,233.33Z"
            fill="#fff"
          />
          <path
            d="M65.36,227.76a4.62,4.62,0,0,1,.9.08,1.3,1.3,0,0,1,.6.29,1.18,1.18,0,0,1,.34.59,4,4,0,0,1,.1,1,2.8,2.8,0,0,1-.08.67,1.41,1.41,0,0,1-.29.54,1.35,1.35,0,0,1-.6.35,3.33,3.33,0,0,1-1,.12,3.81,3.81,0,0,1-.89-.08,1.2,1.2,0,0,1-.57-.3,1.22,1.22,0,0,1-.31-.57,3.19,3.19,0,0,1-.1-.9,1.83,1.83,0,0,1,.43-1.34A1.91,1.91,0,0,1,65.36,227.76Zm-1.55,5.7a2.47,2.47,0,0,1,.12-.73.51.51,0,0,1,.47-.34,4.56,4.56,0,0,1,.72-.11q.41,0,.81,0h.32l.3,0a.39.39,0,0,1,.35.16,1.88,1.88,0,0,1,.06.6c0,1.34,0,2.6,0,3.78s-.1,2.39-.18,3.65c0,.19,0,.35,0,.48a.62.62,0,0,1-.13.32.65.65,0,0,1-.29.18,1.94,1.94,0,0,1-.55.06,8.94,8.94,0,0,1-1-.06c-.39,0-.64-.13-.74-.29a1.4,1.4,0,0,1-.2-.71q0-.67-.06-1.35c0-.44,0-.89,0-1.33,0-.71,0-1.42,0-2.13S63.76,234.2,63.81,233.46Z"
            fill="#fff"
          />
          <path
            d="M68.7,233.31a4.51,4.51,0,0,1,.08-.73.55.55,0,0,1,.45-.38,4.6,4.6,0,0,1,.53-.1c.2,0,.4,0,.62-.06l.64,0,.55,0c.19,0,.31,0,.37.13a.57.57,0,0,1,.1.36,2,2,0,0,1,0,.24q0,.12,0,.27a5.55,5.55,0,0,1,1.48-.74A5.48,5.48,0,0,1,75.1,232a6.1,6.1,0,0,1,.89.08,2.75,2.75,0,0,1,1,.36,2.15,2.15,0,0,1,.77.81,2.86,2.86,0,0,1,.31,1.45c0,.34,0,.73,0,1.19s0,.94-.07,1.46-.08,1.06-.14,1.63-.12,1.13-.19,1.68a1.93,1.93,0,0,1-.18.59.64.64,0,0,1-.63.28c-.19,0-.44,0-.75-.05a7.71,7.71,0,0,1-.88-.14.75.75,0,0,1-.6-.83c0-.14,0-.31,0-.52s0-.49.07-.84.06-.79.08-1.32,0-1.18,0-2a1.32,1.32,0,0,0-.18-.73.61.61,0,0,0-.54-.27,3.07,3.07,0,0,0-1,.18,4.6,4.6,0,0,0-1.08.55c0,.82,0,1.63.07,2.42s.1,1.58.18,2.38l0,.2c0,.07,0,.13,0,.19a.6.6,0,0,1-.2.49,1.43,1.43,0,0,1-.8.21l-.3,0H70.3l-.28,0a1.07,1.07,0,0,1-.76-.26,1.43,1.43,0,0,1-.24-.68c-.1-1-.18-1.93-.25-2.92s-.09-2-.09-3V234C68.68,233.76,68.69,233.54,68.7,233.31Z"
            fill="#fff"
          />
          <path
            d="M83.49,235.78a8.12,8.12,0,0,1,.59-3.08,7.49,7.49,0,0,1,1.62-2.5,7.7,7.7,0,0,1,2.42-1.67,7.37,7.37,0,0,1,3-.62,9.23,9.23,0,0,1,1.48.12l.11-.34a.62.62,0,0,1,.62-.49,3.71,3.71,0,0,1,.89.15,6.05,6.05,0,0,1,1,.37.68.68,0,0,1,.39.67,1.3,1.3,0,0,1,0,.28c-.07.39-.17.81-.28,1.25s-.23.9-.37,1.36-.26.91-.39,1.35-.26.84-.39,1.21a1,1,0,0,1-.25.46.69.69,0,0,1-.45.14h-.13a1.1,1.1,0,0,1-.25,0,5.88,5.88,0,0,1-.59-.11,4.68,4.68,0,0,1-.67-.21.7.7,0,0,1-.44-.36,1,1,0,0,1-.13-.41s0-.08,0-.12,0-.16,0-.33.1-.46.17-.81.16-.7.27-1.08l-.27,0h-.3a3.61,3.61,0,0,0-1.41.3,4.54,4.54,0,0,0-1.28.85,4.44,4.44,0,0,0-.93,1.31,4,4,0,0,0-.36,1.71,3.69,3.69,0,0,0,.21,1.25,2.86,2.86,0,0,0,.6,1,3,3,0,0,0,1,.67,3.36,3.36,0,0,0,1.31.24,6.38,6.38,0,0,0,1.75-.25,10.92,10.92,0,0,0,1.69-.63,1,1,0,0,1,.45-.14.59.59,0,0,1,.45.31,3,3,0,0,1,.48.88,2.89,2.89,0,0,1,.18,1,1.51,1.51,0,0,1-.08.48.87.87,0,0,1-.29.37,6.14,6.14,0,0,1-1.08.63,12.86,12.86,0,0,1-1.32.49,14.11,14.11,0,0,1-1.4.32,8.77,8.77,0,0,1-1.3.11,7.21,7.21,0,0,1-2.43-.41,6.1,6.1,0,0,1-2-1.17,5.54,5.54,0,0,1-1.39-1.9A6.1,6.1,0,0,1,83.49,235.78Z"
            fill="#fff"
          />
          <path
            d="M103,232.18a1.76,1.76,0,0,1,.39.2.48.48,0,0,1,.14.4.71.71,0,0,1,0,.14c0,.06,0,.16,0,.29a4,4,0,0,1,2.31,1.44,4.5,4.5,0,0,1,.4,4.56,4.39,4.39,0,0,1-1.16,1.4,5.1,5.1,0,0,1-1.61.86,6,6,0,0,1-1.81.29,7.69,7.69,0,0,1-2.22-.3,4.53,4.53,0,0,1-1.7-.9,3.81,3.81,0,0,1-1.08-1.47,5,5,0,0,1-.37-2,4.62,4.62,0,0,1,.47-2.1A5,5,0,0,1,98,233.37a5.74,5.74,0,0,1,1.71-1,5.26,5.26,0,0,1,1.94-.37,4.51,4.51,0,0,1,.7.06A4.1,4.1,0,0,1,103,232.18Zm-.59,3.62-.36-.14a.61.61,0,0,1-.24-.17.69.69,0,0,1-.14-.27,1.89,1.89,0,0,1,0-.46,2.51,2.51,0,0,0-1.6.77,2.29,2.29,0,0,0-.64,1.67,1.64,1.64,0,0,0,.16.74,1.5,1.5,0,0,0,.44.56,2.12,2.12,0,0,0,.65.34,2.88,2.88,0,0,0,.78.11,3,3,0,0,0,.79-.11,2.4,2.4,0,0,0,.7-.34,1.92,1.92,0,0,0,.5-.56,1.53,1.53,0,0,0,.18-.74,1.24,1.24,0,0,0-.32-.9A1.75,1.75,0,0,0,102.45,235.8Z"
            fill="#fff"
          />
          <path
            d="M107.87,233.31a4.51,4.51,0,0,1,.08-.73.55.55,0,0,1,.45-.38,4.6,4.6,0,0,1,.53-.1c.2,0,.41,0,.62-.06l.64,0,.55,0a.45.45,0,0,1,.38.13.64.64,0,0,1,.09.36,2.62,2.62,0,0,1,0,.27q0,.17,0,.3a4.33,4.33,0,0,1,1.18-.76,3.48,3.48,0,0,1,1.41-.28.91.91,0,0,1,.79.41,2.58,2.58,0,0,1,.38.89,5.5,5.5,0,0,1,.11,1c0,.35,0,.65,0,.9a1.29,1.29,0,0,1-.2.69,1.94,1.94,0,0,1-.73.61,5.48,5.48,0,0,1-.62.28,1.92,1.92,0,0,1-.6.14.52.52,0,0,1-.49-.28,1,1,0,0,1-.17-.59c0-.14,0-.32,0-.55a3,3,0,0,0-.08-.58l-.48.26a6,6,0,0,0-.54.4c0,.68,0,1.31.05,1.91s.06,1.13.1,1.59.06.84.09,1.15,0,.51,0,.61a.6.6,0,0,1-.2.49,1.43,1.43,0,0,1-.8.21l-.3,0h-.65l-.28,0a1.07,1.07,0,0,1-.76-.26,1.43,1.43,0,0,1-.24-.68c-.1-1-.18-1.93-.24-2.92s-.1-2-.1-3V234C107.85,233.76,107.86,233.54,107.87,233.31Z"
            fill="#fff"
          />
          <path
            d="M116.08,233.31a4.51,4.51,0,0,1,.08-.73.53.53,0,0,1,.45-.38,4.83,4.83,0,0,1,.52-.1c.21,0,.41,0,.63-.06l.64,0,.55,0a.43.43,0,0,1,.37.13.57.57,0,0,1,.1.36c0,.08,0,.15,0,.24l0,.27a5.4,5.4,0,0,1,1.48-.74,5.46,5.46,0,0,1,1.61-.24,6.11,6.11,0,0,1,.9.08,2.82,2.82,0,0,1,.95.36,2.23,2.23,0,0,1,.77.81,3,3,0,0,1,.31,1.45c0,.34,0,.73,0,1.19s0,.94-.08,1.46-.07,1.06-.13,1.63-.12,1.13-.2,1.68a1.68,1.68,0,0,1-.17.59c-.1.19-.31.28-.64.28s-.43,0-.74-.05a7.71,7.71,0,0,1-.88-.14.75.75,0,0,1-.6-.83c0-.14,0-.31,0-.52s0-.49.07-.84.06-.79.08-1.32,0-1.18,0-2a1.41,1.41,0,0,0-.17-.73.61.61,0,0,0-.54-.27,3.07,3.07,0,0,0-1,.18,4.41,4.41,0,0,0-1.08.55c0,.82,0,1.63.07,2.42s.1,1.58.18,2.38l0,.2v.19a.6.6,0,0,1-.19.49,1.47,1.47,0,0,1-.81.21l-.29,0h-.65l-.28,0a1.1,1.1,0,0,1-.77-.26,1.43,1.43,0,0,1-.23-.68c-.1-1-.18-1.93-.25-2.92s-.09-2-.09-3V234C116.06,233.76,116.06,233.54,116.08,233.31Z"
            fill="#fff"
          />
          <path
            d="M135.38,237a10,10,0,0,1-1.15.32c-.45.1-.94.19-1.44.26s-1,.14-1.59.2-1.07.1-1.58.12a2.71,2.71,0,0,0,1,.69,3.11,3.11,0,0,0,1.25.26,5.26,5.26,0,0,0,1.15-.15,5.37,5.37,0,0,0,1.21-.4,1.21,1.21,0,0,1,.4-.13.25.25,0,0,1,.22.1,1.28,1.28,0,0,1,.15.31c.05.14.09.28.13.42s.06.27.08.41a.54.54,0,0,1,0,.2v.18a.86.86,0,0,1-.3.64,4,4,0,0,1-1.6.88,7.49,7.49,0,0,1-2.31.33,4.8,4.8,0,0,1-3.29-1.3,5,5,0,0,1-1-1.49,4.72,4.72,0,0,1-.39-1.95,4.83,4.83,0,0,1,.4-2,4.93,4.93,0,0,1,1.09-1.56,4.68,4.68,0,0,1,1.57-1,5,5,0,0,1,1.86-.36,4.62,4.62,0,0,1,2.2.47,4.37,4.37,0,0,1,1.43,1.15,4.48,4.48,0,0,1,1,2.66.91.91,0,0,1-.09.41A.72.72,0,0,1,135.38,237Zm-4.11-2.4a2.08,2.08,0,0,0-1.23.4,1.89,1.89,0,0,0-.77,1l1.79-.12a10.69,10.69,0,0,0,1.73-.26,1.31,1.31,0,0,0-.65-.78A1.79,1.79,0,0,0,131.27,234.63Z"
            fill="#fff"
          />
          <path
            d="M136.81,233.31a4.4,4.4,0,0,1,.09-.73.52.52,0,0,1,.44-.38,5.06,5.06,0,0,1,.53-.1c.2,0,.41,0,.62-.06l.64,0,.55,0c.19,0,.32,0,.38.13a.64.64,0,0,1,.09.36,2.62,2.62,0,0,1,0,.27,2.66,2.66,0,0,1,0,.3,4.28,4.28,0,0,1,1.17-.76,3.51,3.51,0,0,1,1.41-.28.91.91,0,0,1,.79.41,2.4,2.4,0,0,1,.38.89,5.5,5.5,0,0,1,.11,1c0,.35,0,.65,0,.9a1.21,1.21,0,0,1-.2.69,2,2,0,0,1-.72.61,6.44,6.44,0,0,1-.62.28,2,2,0,0,1-.61.14.53.53,0,0,1-.49-.28,1.12,1.12,0,0,1-.17-.59c0-.14,0-.32,0-.55a4.19,4.19,0,0,0-.07-.58,5.21,5.21,0,0,0-.48.26,4.07,4.07,0,0,0-.54.4c0,.68,0,1.31,0,1.91s.06,1.13.09,1.59.06.84.09,1.15a5.13,5.13,0,0,1,.05.61.58.58,0,0,1-.2.49,1.43,1.43,0,0,1-.8.21l-.29,0h-.65l-.29,0a1.07,1.07,0,0,1-.76-.26,1.43,1.43,0,0,1-.24-.68c-.1-1-.18-1.93-.24-2.92s-.1-2-.1-3V234C136.79,233.76,136.8,233.54,136.81,233.31Z"
            fill="#fff"
          />
        </g>
      </g>
      <g
        id="a5630da6-e402-461b-b76e-defe07282746"
        data-name="light"
        pointerEvents="none"
      >
        <polygon
          points="283.24 2.68 831.38 496.21 730.92 486.31 283.24 2.68"
          fill="#fff"
          opacity="0.13"
        />
        <polygon
          points="438 655.59 436.42 655.39 435.83 655.32 432.87 654.95 432.63 654.92 427.16 654.24 423.84 653.83 409.26 652.02 402.75 651.21 396.32 650.41 394.29 650.16 393.65 650.08 373.31 647.56 370.7 647.23 370.65 647.23 367.57 646.84 361.13 646.04 357.41 645.58 357.36 645.58 356.37 645.45 340.63 643.5 337.63 643.13 327.68 641.89 326.72 641.77 288.54 637.03 272.07 609.06 271.18 607.55 254.8 579.75 254.67 579.53 235.6 547.14 224.28 527.93 222.61 525.1 220.67 521.81 218.93 518.85 209.83 503.4 196.74 481.17 174.67 443.7 174.26 443 166.94 430.58 152.15 405.47 151.73 404.76 131.13 369.78 119.34 349.76 118.45 348.25 94.86 308.21 87.95 296.47 76.67 277.31 74.64 273.87 74.58 273.76 72.83 270.79 70.85 267.43 69.19 264.62 68.24 263 54.87 240.3 17.64 177.09 0 147.14 0 32.05 3.2 36.61 74.96 138.77 76.36 140.76 77.22 141.99 77.23 142 78.77 144.19 81.04 147.42 82.94 150.13 93.48 165.13 94.22 166.18 98.88 172.81 100.52 175.16 102.99 178.67 107.81 185.54 108.79 186.92 112.65 192.42 119.93 202.78 122.35 206.24 122.36 206.26 122.37 206.28 124.71 209.59 132.62 220.85 132.63 220.87 135.87 225.47 135.87 225.48 170.26 274.43 180.11 288.46 184.45 294.64 205.7 324.89 206.98 326.7 221.3 347.09 250.08 388.06 251.1 389.52 267.32 412.6 268.8 414.72 281.4 432.65 317.19 483.61 331.75 504.33 345.78 524.3 351.34 532.22 351.89 533.01 352.27 533.54 352.57 533.97 358.5 542.41 363.77 549.92 364.48 550.93 364.5 550.96 366.14 553.29 367.58 555.34 367.9 555.79 368.53 556.69 368.95 557.29 369.26 557.73 369.36 557.87 373.21 563.36 373.56 563.85 374.25 564.84 382.74 576.92 384.62 579.59 384.78 579.83 388.6 585.26 390.07 587.36 390.22 587.56 394.66 593.9 396.55 596.58 396.68 596.76 398.1 598.78 411.34 617.64 416.11 624.42 417.04 625.76 417.16 625.93 419.48 629.22 420.06 630.05 423.03 634.28 423.85 635.45 424.12 635.83 424.16 635.88 425.09 637.21 425.27 637.47 426.79 639.64 434.17 650.13 435.1 651.47 435.65 652.24 436.2 653.03 436.26 653.11 437.44 654.8 438 655.59"
          fill="#fff"
          opacity="0.13"
        />
        <polygon
          points="1372.66 208.31 1207.31 257.86 1145.05 195.82 1100.07 150.99 1100.06 150.99 948.55 0 1101.03 0 1251.51 115.4 1330.32 175.84 1372.66 208.31"
          fill="#fff"
          opacity="0.13"
        />
        <polygon
          points="1328 777 1119 777 1068.31 714.56 1055.26 698.48 1029.01 666.14 1028.7 665.77 981.59 607.73 854.62 451.33 832.65 424.27 815.17 402.74 815.17 402.73 798.46 382.15 789.87 371.56 750.6 323.2 737.26 306.76 737.09 306.55 731.72 299.93 694.12 253.62 674.42 229.35 596.11 132.89 565.13 94.72 488.23 0 524.09 0 764.55 232.41 774.21 241.75 829.5 295.18 836.8 302.24 841.78 307.05 862.82 327.38 878.43 342.48 882.67 346.57 909.36 372.37 928.04 390.42 956.46 417.89 956.46 417.9 958.53 419.9 1151.47 606.38 1177.25 631.29 1189.68 643.31 1209.29 662.26 1232.62 684.81 1240.22 692.16 1242.22 694.09 1256.69 708.08 1259.74 711.02 1259.96 711.24 1265.25 716.35 1266.91 717.95 1266.91 717.96 1268.47 719.46 1280.08 730.69 1289.36 739.66 1311.14 760.7 1311.14 760.71 1328 777"
          fill="#fff"
          opacity="0.13"
        />
        <polygon
          points="1279.27 452.03 1113.92 501.58 1005.59 393.63 974.48 362.62 974.47 362.62 974.08 362.23 973.19 361.34 972.33 360.49 972.08 360.23 972.07 360.23 970.46 358.62 969.54 357.7 968.49 356.66 966.96 355.13 964.92 353.1 961.99 350.18 951.84 340.07 951.66 339.88 950.48 338.71 946.89 335.14 946.4 334.65 946.4 334.64 945.11 333.36 936.44 324.72 927.82 316.13 926.56 314.88 918.57 306.91 866.78 255.31 844.93 233.52 844.92 233.52 835.37 224.01 799.02 187.78 689.02 78.16 684.98 74.14 610.58 0 689.82 0 748.84 45.26 757.19 51.66 768.07 60.01 776.33 66.34 780.53 69.56 791.8 78.2 885.46 150.03 985.49 226.74 986.99 227.89 1004.02 240.95 1006.49 242.84 1008.72 244.55 1009.71 245.31 1010.58 245.98 1010.84 246.18 1021 253.97 1059.35 283.38 1060.74 284.45 1149.06 352.18 1149.07 352.18 1279.27 452.03"
          fill="#fff"
          opacity="0.13"
        />
        <circle cx="819.95" cy="203.13" r="25.96" fill="#fff" opacity="0.13" />
        <circle cx="587.12" cy="108.52" r="25.96" fill="#fff" opacity="0.13" />
        <circle cx="442.92" cy="56.78" r="7.92" fill="#fff" opacity="0.13" />
        <circle cx="749.4" cy="53.16" r="7.92" fill="#fff" opacity="0.13" />
        <circle cx="832.79" cy="37.62" r="7.92" fill="#fff" opacity="0.13" />
      </g>
    </>
  );
};

export default MapBg;
